function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { useEffect, useRef, useState } from "react";
import { UI, panelFieldStyle, BuilderIcon } from "../../../builderUiTheme";
import { CLIP_PATH_PRESETS, GOOGLE_FONTS, POPULAR_GOOGLE_FONT_NAMES, resolveElementPartLabel, BLOCK_GAP_DEFAULTS } from "../../constants/defaultBlocks";
import { getBackgroundImageUrl, getBackgroundOverlayOpacity, getBackgroundOverlayColor, isNestedColumnContent, getColumnBackgroundLabel, getLayoutColumnCount, MIN_LAYOUT_COLUMNS, MAX_LAYOUT_COLUMNS, ensureGoogleFontLoaded, parseLineHeight, formatLineHeight, LINE_HEIGHT_UNITS, getColumnStyleValue, isColumnLayoutType } from "../../utils/helpers";
import ColorPickerField from "./ColorPickerField";
import IconPickerField from "./IconPickerField";
import { SpacingControls, RadiusControls, LayoutControls, GapControls, ColumnShellControls, ColumnBorderControls, ColumnFlexControls, TableBorderControls, TableCellPaddingControls } from "./SpacingField";
import { templateCardStyle } from "../../constants/templates";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var panelInputStyle = _objectSpread({}, panelFieldStyle);
function rightPanelTabStyle(isActive) {
  return {
    flex: "1 1 0",
    minWidth: 0,
    border: "none",
    borderBottom: isActive ? "2px solid #101828" : "2px solid transparent",
    background: "transparent",
    color: isActive ? "#101828" : "#6b7280",
    marginBottom: -1,
    padding: "10px 2px",
    borderRadius: 0,
    cursor: "pointer",
    fontFamily: "DM Sans, sans-serif",
    fontSize: 12,
    fontWeight: isActive ? 600 : 500,
    lineHeight: 1.2,
    whiteSpace: "nowrap"
  };
}
function SavedTemplatePicker(_ref) {
  var savedTemplates = _ref.savedTemplates,
    savedTemplatesLoading = _ref.savedTemplatesLoading,
    onSelectSavedTemplate = _ref.onSelectSavedTemplate;
  return /*#__PURE__*/_jsxs("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      gap: 10,
      padding: 16
    },
    children: [/*#__PURE__*/_jsx("div", {
      style: {
        fontSize: 12,
        color: "#94a3b8",
        fontWeight: 500,
        margin: 0
      },
      children: "Selecting a template will replace the current design."
    }), savedTemplatesLoading && /*#__PURE__*/_jsx("div", {
      style: {
        color: "#94a3b8",
        fontSize: 13,
        fontFamily: "DM Sans, sans-serif"
      },
      children: "Loading templates..."
    }), !savedTemplatesLoading && savedTemplates.length === 0 && /*#__PURE__*/_jsx("div", {
      style: {
        color: "#94a3b8",
        fontSize: 13,
        fontFamily: "DM Sans, sans-serif"
      },
      children: "No new templates yet."
    }), !savedTemplatesLoading && savedTemplates.map(function (template) {
      return /*#__PURE__*/_jsxs("button", {
        type: "button",
        onClick: function onClick() {
          return onSelectSavedTemplate && onSelectSavedTemplate(template);
        },
        style: _objectSpread(_objectSpread({}, templateCardStyle), {}, {
          textAlign: "left",
          padding: 6
        }),
        onMouseEnter: function onMouseEnter(e) {
          e.currentTarget.style.borderColor = "#0f172a";
          e.currentTarget.style.transform = "translateY(-1px)";
          e.currentTarget.style.boxShadow = "0 4px 12px rgba(15, 23, 42, 0.05)";
        },
        onMouseLeave: function onMouseLeave(e) {
          e.currentTarget.style.borderColor = "#e2e8f0";
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "none";
        },
        children: [template.previewUrl ? /*#__PURE__*/_jsx("div", {
          style: {
            position: "relative",
            width: "100%",
            height: 148,
            overflow: "hidden",
            borderRadius: 8,
            background: "#f8fafc",
            pointerEvents: "none"
          },
          children: /*#__PURE__*/_jsx("iframe", {
            src: template.previewUrl,
            title: template.name,
            loading: "lazy",
            scrolling: "no",
            style: {
              border: "none",
              transform: "scale(0.22)",
              transformOrigin: "top left",
              width: "455%",
              height: 680,
              background: "#ffffff"
            }
          })
        }) : null, /*#__PURE__*/_jsxs("span", {
          style: {
            fontFamily: "DM Sans, sans-serif",
            fontSize: 13,
            fontWeight: 600,
            color: "#1e293b",
            padding: "2px 4px 4px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          },
          children: [template.name, template.is_duplicate ? " (Duplicate)" : ""]
        })]
      }, template.id);
    })]
  });
}
function getTransformValues() {
  var transform = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var read = function read(name) {
    var match = String(transform).match(new RegExp("".concat(name, "\\((-?[\\d.]+)deg\\)")));
    return match ? parseFloat(match[1]) : 0;
  };
  return {
    rotate: read("rotate"),
    skewX: read("skewX"),
    skewY: read("skewY")
  };
}
function buildTransform(values) {
  return [values.rotate ? "rotate(".concat(values.rotate, "deg)") : "", values.skewX ? "skewX(".concat(values.skewX, "deg)") : "", values.skewY ? "skewY(".concat(values.skewY, "deg)") : ""].filter(Boolean).join(" ") || "none";
}
function getGradientValues() {
  var background = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var match = String(background).match(/linear-gradient\(\s*(-?[\d.]+)deg\s*,\s*(#[\da-fA-F]{3,8})\s*(?:\d+%)?\s*,\s*(#[\da-fA-F]{3,8})/i);
  return match ? {
    angle: parseFloat(match[1]),
    start: match[2],
    end: match[3]
  } : {
    angle: 135,
    start: "#fef3c7",
    end: "#7c2d12"
  };
}
function buildGradient(_ref2) {
  var angle = _ref2.angle,
    start = _ref2.start,
    end = _ref2.end;
  return "linear-gradient(".concat(angle, "deg, ").concat(start, " 0%, ").concat(end, " 100%)");
}
function SearchableFontSelect(_ref3) {
  var value = _ref3.value,
    onChange = _ref3.onChange,
    _ref3$includeDefault = _ref3.includeDefault,
    includeDefault = _ref3$includeDefault === void 0 ? false : _ref3$includeDefault,
    _ref3$defaultLabel = _ref3.defaultLabel,
    defaultLabel = _ref3$defaultLabel === void 0 ? "Default / Inherit Global Font" : _ref3$defaultLabel;
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    search = _useState2[0],
    setSearch = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isOpen = _useState4[0],
    setIsOpen = _useState4[1];
  var rootRef = useRef(null);
  var normalizedSearch = search.trim().toLowerCase();
  var selectedFont = GOOGLE_FONTS.find(function (font) {
    return font.value === value;
  });
  var matchingFonts = function () {
    if (normalizedSearch) {
      return GOOGLE_FONTS.filter(function (font) {
        return font.name.toLowerCase().includes(normalizedSearch);
      }).slice(0, 120);
    }
    var popular = new Set(POPULAR_GOOGLE_FONT_NAMES);
    var list = GOOGLE_FONTS.filter(function (font) {
      return popular.has(font.name) || font.value === value;
    });
    // Keep popular order, then selected if not already included
    var byName = new Map(list.map(function (f) {
      return [f.name, f];
    }));
    var ordered = POPULAR_GOOGLE_FONT_NAMES.map(function (n) {
      return byName.get(n);
    }).filter(Boolean);
    if (selectedFont && !popular.has(selectedFont.name)) ordered.unshift(selectedFont);
    return ordered;
  }();
  useEffect(function () {
    if (value) ensureGoogleFontLoaded(value);
  }, [value]);
  useEffect(function () {
    if (!isOpen) return undefined;
    var closeOnOutsideClick = function closeOnOutsideClick(event) {
      var _rootRef$current;
      if (!((_rootRef$current = rootRef.current) !== null && _rootRef$current !== void 0 && _rootRef$current.contains(event.target))) {
        setIsOpen(false);
        setSearch("");
      }
    };
    document.addEventListener("mousedown", closeOnOutsideClick);
    return function () {
      return document.removeEventListener("mousedown", closeOnOutsideClick);
    };
  }, [isOpen]);
  var selectFont = function selectFont(fontValue) {
    if (fontValue) ensureGoogleFontLoaded(fontValue);
    onChange(fontValue);
    setSearch("");
    setIsOpen(false);
  };
  return /*#__PURE__*/_jsxs("div", {
    ref: rootRef,
    style: {
      position: "relative",
      width: "100%"
    },
    children: [/*#__PURE__*/_jsxs("button", {
      type: "button",
      onClick: function onClick() {
        return setIsOpen(function (open) {
          return !open;
        });
      },
      style: _objectSpread(_objectSpread({}, panelFieldStyle), {}, {
        width: "100%",
        padding: "8px 10px",
        fontSize: 13,
        fontFamily: value || "DM Sans, sans-serif",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        textAlign: "left",
        cursor: "pointer"
      }),
      children: [/*#__PURE__*/_jsx("span", {
        style: {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        },
        children: (selectedFont === null || selectedFont === void 0 ? void 0 : selectedFont.name) || defaultLabel
      }), /*#__PURE__*/_jsx("span", {
        "aria-hidden": "true",
        style: {
          marginLeft: 8,
          fontFamily: "sans-serif"
        },
        children: isOpen ? "▴" : "▾"
      })]
    }), isOpen && /*#__PURE__*/_jsxs("div", {
      style: {
        position: "absolute",
        top: "calc(100% + 4px)",
        left: 0,
        right: 0,
        zIndex: 200,
        background: "#ffffff",
        border: "1px solid #d1d5db",
        borderRadius: 8,
        boxShadow: "0 10px 24px rgba(15, 23, 42, 0.16)",
        padding: 6
      },
      children: [/*#__PURE__*/_jsx("input", {
        autoFocus: true,
        type: "search",
        value: search,
        onChange: function onChange(event) {
          return setSearch(event.target.value);
        },
        onKeyDown: function onKeyDown(event) {
          if (event.key === "Escape") {
            setIsOpen(false);
            setSearch("");
          }
        },
        placeholder: "Search ".concat(GOOGLE_FONTS.length, " Google Fonts..."),
        "aria-label": "Search fonts",
        style: _objectSpread(_objectSpread({}, panelFieldStyle), {}, {
          width: "100%",
          padding: "8px 10px",
          marginBottom: 6,
          fontSize: 13,
          fontFamily: "DM Sans, sans-serif"
        })
      }), !normalizedSearch && /*#__PURE__*/_jsx("div", {
        style: {
          color: "#94a3b8",
          padding: "2px 9px 8px",
          fontSize: 11
        },
        children: "Popular fonts \u2014 type to search all Google Fonts"
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          maxHeight: 220,
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
          gap: 2
        },
        children: [includeDefault && !normalizedSearch && /*#__PURE__*/_jsx("button", {
          type: "button",
          onClick: function onClick() {
            return selectFont("");
          },
          style: {
            border: "none",
            borderRadius: 5,
            background: !value ? "#eef2ff" : "transparent",
            color: "#334155",
            padding: "8px 9px",
            textAlign: "left",
            cursor: "pointer",
            fontSize: 13
          },
          children: defaultLabel
        }), matchingFonts.map(function (font) {
          return /*#__PURE__*/_jsx("button", {
            type: "button",
            onMouseEnter: function onMouseEnter() {
              return ensureGoogleFontLoaded(font.value);
            },
            onClick: function onClick() {
              return selectFont(font.value);
            },
            style: {
              border: "none",
              borderRadius: 5,
              background: font.value === value ? "#eef2ff" : "transparent",
              color: "#334155",
              padding: "8px 9px",
              textAlign: "left",
              cursor: "pointer",
              fontSize: 13,
              fontFamily: font.value
            },
            children: font.name
          }, font.value);
        }), matchingFonts.length === 0 && /*#__PURE__*/_jsx("div", {
          style: {
            color: "#94a3b8",
            padding: "10px",
            textAlign: "center",
            fontSize: 12
          },
          children: "No fonts found"
        }), normalizedSearch && matchingFonts.length >= 120 && /*#__PURE__*/_jsx("div", {
          style: {
            color: "#94a3b8",
            padding: "8px 9px",
            fontSize: 11
          },
          children: "Showing first 120 matches \u2014 refine your search"
        })]
      })]
    })]
  });
}
function ImageUploadField(_ref4) {
  var label = _ref4.label,
    value = _ref4.value,
    onUrlChange = _ref4.onUrlChange,
    onFileChange = _ref4.onFileChange,
    uploading = _ref4.uploading,
    onRemove = _ref4.onRemove,
    error = _ref4.error;
  var fileRef = useRef(null);
  return /*#__PURE__*/_jsxs("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      gap: 10
    },
    children: [/*#__PURE__*/_jsx("label", {
      style: {
        fontSize: 14,
        fontWeight: 500,
        color: "#4b5563"
      },
      children: label
    }), value && /*#__PURE__*/_jsx("div", {
      style: {
        background: UI.surface,
        border: "1px solid ".concat(UI.surfaceBorder),
        borderRadius: 8,
        padding: 8,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: 80,
        overflow: "hidden"
      },
      children: /*#__PURE__*/_jsx("img", {
        src: value,
        alt: "Preview",
        style: {
          maxWidth: "100%",
          maxHeight: 140,
          borderRadius: 6,
          objectFit: "contain"
        }
      })
    }), /*#__PURE__*/_jsxs("div", {
      style: {
        display: "flex",
        gap: 8
      },
      children: [/*#__PURE__*/_jsx("button", {
        type: "button",
        onClick: function onClick() {
          var _fileRef$current;
          return (_fileRef$current = fileRef.current) === null || _fileRef$current === void 0 ? void 0 : _fileRef$current.click();
        },
        disabled: uploading,
        style: {
          flex: 1,
          background: uploading ? "#334155" : "#101828",
          color: "#ffffff",
          border: "none",
          borderRadius: 6,
          padding: "8px 12px",
          fontFamily: "DM Sans, sans-serif",
          fontSize: 14,
          fontWeight: 500,
          cursor: uploading ? "not-allowed" : "pointer",
          opacity: uploading ? 0.7 : 1
        },
        children: uploading ? "Uploading..." : "Upload Image"
      }), value && onRemove && /*#__PURE__*/_jsx("button", {
        type: "button",
        onClick: onRemove,
        style: {
          background: UI.surface,
          color: UI.text,
          border: "1px solid ".concat(UI.inputBorder),
          borderRadius: 6,
          padding: "8px 12px",
          fontFamily: "DM Sans, sans-serif",
          fontWeight: 500,
          fontSize: 14,
          cursor: "pointer"
        },
        children: "Remove"
      })]
    }), /*#__PURE__*/_jsx("input", {
      ref: fileRef,
      type: "file",
      accept: "image/jpeg,image/jpg,image/png,image/gif,image/webp",
      style: {
        display: "none"
      },
      onChange: onFileChange
    }), /*#__PURE__*/_jsx("span", {
      style: {
        fontSize: 12,
        fontWeight: 500,
        color: "#64748b"
      },
      children: "or paste image URL"
    }), /*#__PURE__*/_jsx("input", {
      type: "text",
      value: value || "",
      onChange: function onChange(e) {
        return onUrlChange(e.target.value);
      },
      placeholder: "https://example.com/image.jpg",
      style: _objectSpread(_objectSpread({}, panelFieldStyle), {}, {
        fontFamily: "DM Sans, sans-serif",
        fontSize: 14,
        fontWeight: 500,
        color: "#64748b"
      })
    }), /*#__PURE__*/_jsx("span", {
      style: {
        fontSize: 12,
        fontWeight: 500,
        color: "#64748b"
      },
      children: "JPG, PNG, GIF, WEBP \u2014 max 2 MB"
    }), error && /*#__PURE__*/_jsx("div", {
      style: {
        marginTop: 2,
        padding: "9px 12px",
        borderRadius: 8,
        background: "#ef4444",
        color: "#ffffff",
        fontSize: 12,
        fontWeight: 600,
        fontFamily: "DM Sans, sans-serif",
        lineHeight: 1.4
      },
      children: error
    })]
  });
}
function ImageUploadItem(_ref5) {
  var value = _ref5.value,
    onUrlChange = _ref5.onUrlChange,
    onFileChange = _ref5.onFileChange,
    uploading = _ref5.uploading,
    alt = _ref5.alt,
    onAltChange = _ref5.onAltChange,
    _ref5$altPlaceholder = _ref5.altPlaceholder,
    altPlaceholder = _ref5$altPlaceholder === void 0 ? "Alt text" : _ref5$altPlaceholder,
    error = _ref5.error;
  var fileRef = useRef(null);
  return /*#__PURE__*/_jsxs("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      gap: 8
    },
    children: [value && /*#__PURE__*/_jsx("div", {
      style: {
        background: UI.surface,
        borderRadius: 6,
        padding: 6,
        display: "flex",
        justifyContent: "center",
        border: "1px solid ".concat(UI.surfaceBorder)
      },
      children: /*#__PURE__*/_jsx("img", {
        src: value,
        alt: "Preview",
        style: {
          maxWidth: "100%",
          maxHeight: 72,
          borderRadius: 4,
          objectFit: "contain"
        }
      })
    }), /*#__PURE__*/_jsx("button", {
      type: "button",
      onClick: function onClick() {
        var _fileRef$current2;
        return (_fileRef$current2 = fileRef.current) === null || _fileRef$current2 === void 0 ? void 0 : _fileRef$current2.click();
      },
      disabled: uploading,
      style: {
        width: "100%",
        background: uploading ? "#334155" : "#101828",
        color: "#ffffff",
        border: "none",
        borderRadius: 6,
        padding: "7px 10px",
        fontFamily: "DM Sans, sans-serif",
        fontSize: 12,
        fontWeight: 500,
        cursor: uploading ? "not-allowed" : "pointer",
        opacity: uploading ? 0.7 : 1
      },
      children: uploading ? "Uploading..." : "Upload Image"
    }), /*#__PURE__*/_jsx("input", {
      ref: fileRef,
      type: "file",
      accept: "image/jpeg,image/jpg,image/png,image/gif,image/webp",
      style: {
        display: "none",
        fontFamily: "DM Sans, sans-serif",
        fontSize: 12,
        fontWeight: 500
      },
      onChange: onFileChange
    }), /*#__PURE__*/_jsx("input", {
      type: "text",
      value: value || "",
      onChange: function onChange(e) {
        return onUrlChange(e.target.value);
      },
      placeholder: "or paste image URL",
      style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
        fontFamily: "DM Sans, sans-serif",
        fontSize: 12,
        fontWeight: 500
      })
    }), onAltChange && /*#__PURE__*/_jsx("input", {
      type: "text",
      value: alt || "",
      onChange: function onChange(e) {
        return onAltChange(e.target.value);
      },
      placeholder: altPlaceholder,
      style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
        fontFamily: "DM Sans, sans-serif",
        fontSize: 12,
        fontWeight: 500
      })
    }), error && /*#__PURE__*/_jsx("div", {
      style: {
        padding: "8px 10px",
        borderRadius: 8,
        background: "#ef4444",
        color: "#ffffff",
        fontSize: 12,
        fontWeight: 600,
        fontFamily: "DM Sans, sans-serif",
        lineHeight: 1.4
      },
      children: error
    })]
  });
}
function GlobalSettingsFields(_ref6) {
  var getActiveFontFamily = _ref6.getActiveFontFamily,
    handleFontChange = _ref6.handleFontChange,
    getActiveTextColor = _ref6.getActiveTextColor,
    applyGlobalTextColor = _ref6.applyGlobalTextColor,
    getActiveButtonBackgroundColor = _ref6.getActiveButtonBackgroundColor,
    applyGlobalButtonBackgroundColor = _ref6.applyGlobalButtonBackgroundColor,
    getActiveButtonTextColor = _ref6.getActiveButtonTextColor,
    applyGlobalButtonTextColor = _ref6.applyGlobalButtonTextColor,
    getActiveBackgroundColor = _ref6.getActiveBackgroundColor,
    applyGlobalBackgroundColor = _ref6.applyGlobalBackgroundColor,
    getActiveBackgroundImage = _ref6.getActiveBackgroundImage,
    setGlobalBackgroundImageUrl = _ref6.setGlobalBackgroundImageUrl,
    handleGlobalBackgroundImageUpload = _ref6.handleGlobalBackgroundImageUpload,
    imageUploading = _ref6.imageUploading,
    imageUploadError = _ref6.imageUploadError,
    _ref6$documentPadding = _ref6.documentPadding,
    documentPadding = _ref6$documentPadding === void 0 ? 30 : _ref6$documentPadding,
    setDocumentPadding = _ref6.setDocumentPadding,
    _ref6$documentPageSiz = _ref6.documentPageSize,
    documentPageSize = _ref6$documentPageSiz === void 0 ? "auto" : _ref6$documentPageSiz,
    setDocumentPageSize = _ref6.setDocumentPageSize,
    _ref6$showSafeArea = _ref6.showSafeArea,
    showSafeArea = _ref6$showSafeArea === void 0 ? false : _ref6$showSafeArea,
    setShowSafeArea = _ref6.setShowSafeArea,
    _ref6$showGrid = _ref6.showGrid,
    showGrid = _ref6$showGrid === void 0 ? false : _ref6$showGrid,
    setShowGrid = _ref6.setShowGrid;
  return /*#__PURE__*/_jsx("div", {
    style: {
      display: "flex",
      flexDirection: "column"
    },
    children: /*#__PURE__*/_jsxs("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        gap: 24,
        padding: 20
      },
      children: [/*#__PURE__*/_jsxs("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          gap: 8
        },
        children: [/*#__PURE__*/_jsx("label", {
          style: {
            fontSize: 14,
            fontWeight: 600,
            color: "#4b5563"
          },
          children: "Global Font Family"
        }), /*#__PURE__*/_jsx(SearchableFontSelect, {
          value: getActiveFontFamily(),
          onChange: handleFontChange
        })]
      }), /*#__PURE__*/_jsx(ColorPickerField, {
        label: "Global Text Color",
        value: getActiveTextColor(),
        onChange: function onChange(val) {
          return applyGlobalTextColor(val);
        }
      }), /*#__PURE__*/_jsx(ColorPickerField, {
        label: "Global Button Background",
        value: typeof getActiveButtonBackgroundColor === "function" ? getActiveButtonBackgroundColor() : "#101828",
        onChange: function onChange(val) {
          return applyGlobalButtonBackgroundColor === null || applyGlobalButtonBackgroundColor === void 0 ? void 0 : applyGlobalButtonBackgroundColor(val);
        }
      }), /*#__PURE__*/_jsx(ColorPickerField, {
        label: "Global Button Text Color",
        value: typeof getActiveButtonTextColor === "function" ? getActiveButtonTextColor() : "#ffffff",
        onChange: function onChange(val) {
          return applyGlobalButtonTextColor === null || applyGlobalButtonTextColor === void 0 ? void 0 : applyGlobalButtonTextColor(val);
        }
      }), /*#__PURE__*/_jsx(ColorPickerField, {
        label: "Document Background",
        value: getActiveBackgroundColor(),
        onChange: function onChange(val) {
          return applyGlobalBackgroundColor(val);
        }
      }), /*#__PURE__*/_jsx(ImageUploadField, {
        label: "Document Background Image",
        value: typeof getActiveBackgroundImage === "function" ? getActiveBackgroundImage() : "",
        onUrlChange: function onUrlChange(url) {
          return setGlobalBackgroundImageUrl === null || setGlobalBackgroundImageUrl === void 0 ? void 0 : setGlobalBackgroundImageUrl(url);
        },
        onFileChange: handleGlobalBackgroundImageUpload,
        uploading: imageUploading === "global-background-image",
        onRemove: function onRemove() {
          return setGlobalBackgroundImageUrl === null || setGlobalBackgroundImageUrl === void 0 ? void 0 : setGlobalBackgroundImageUrl("");
        },
        error: (imageUploadError === null || imageUploadError === void 0 ? void 0 : imageUploadError.key) === "global-background-image" ? imageUploadError.message : null
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          gap: 8
        },
        children: [/*#__PURE__*/_jsxs("div", {
          style: {
            display: "flex",
            justifyContent: "space-between",
            fontSize: 14,
            fontWeight: 600,
            color: "#4b5563"
          },
          children: [/*#__PURE__*/_jsx("span", {
            children: "Document Padding"
          }), /*#__PURE__*/_jsxs("span", {
            style: {
              color: "#64748b",
              fontWeight: 500
            },
            children: [documentPadding, "px"]
          })]
        }), /*#__PURE__*/_jsx("input", {
          type: "range",
          min: "0",
          max: "80",
          value: documentPadding,
          onChange: function onChange(e) {
            return setDocumentPadding === null || setDocumentPadding === void 0 ? void 0 : setDocumentPadding(parseInt(e.target.value, 10));
          },
          style: {
            width: "100%",
            cursor: "pointer",
            accentColor: "#101828"
          }
        }), /*#__PURE__*/_jsx("p", {
          style: {
            margin: 0,
            fontSize: 12,
            color: "#64748b"
          },
          children: "Set to 0 for full-bleed edge-to-edge backgrounds."
        })]
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          gap: 8
        },
        children: [/*#__PURE__*/_jsx("label", {
          style: {
            fontSize: 14,
            fontWeight: 600,
            color: "#4b5563"
          },
          children: "Print Page Size"
        }), /*#__PURE__*/_jsxs("select", {
          value: documentPageSize,
          onChange: function onChange(e) {
            return setDocumentPageSize === null || setDocumentPageSize === void 0 ? void 0 : setDocumentPageSize(e.target.value);
          },
          style: _objectSpread(_objectSpread({}, panelFieldStyle), {}, {
            padding: "8px 10px",
            cursor: "pointer"
          }),
          children: [/*#__PURE__*/_jsx("option", {
            value: "auto",
            children: "Auto / Web"
          }), /*#__PURE__*/_jsx("option", {
            value: "a4",
            children: "A4"
          }), /*#__PURE__*/_jsx("option", {
            value: "letter",
            children: "US Letter"
          }), /*#__PURE__*/_jsx("option", {
            value: "legal",
            children: "US Legal"
          })]
        }), /*#__PURE__*/_jsxs("label", {
          style: {
            display: "flex",
            alignItems: "center",
            gap: 8,
            fontSize: 12,
            color: "#475569"
          },
          children: [/*#__PURE__*/_jsx("input", {
            type: "checkbox",
            checked: showSafeArea,
            onChange: function onChange(e) {
              return setShowSafeArea === null || setShowSafeArea === void 0 ? void 0 : setShowSafeArea(e.target.checked);
            }
          }), "Show print safe-area guide"]
        }), /*#__PURE__*/_jsxs("label", {
          style: {
            display: "flex",
            alignItems: "center",
            gap: 8,
            fontSize: 12,
            color: "#475569"
          },
          children: [/*#__PURE__*/_jsx("input", {
            type: "checkbox",
            checked: showGrid,
            onChange: function onChange(e) {
              return setShowGrid === null || setShowGrid === void 0 ? void 0 : setShowGrid(e.target.checked);
            }
          }), "Show 10px grid (movement snaps to 5px)"]
        })]
      })]
    })
  });
}
export default function PropertiesPanel(_ref7) {
  var _ref8, _active$elementStyles, _active$content, _active$content2, _active$content3, _active$content4, _active$content5, _active$content6, _active$content7, _active$content8, _active$style, _active$style2, _active$style4, _active$style5, _active$content9, _active$content10, _active$content11, _active$content12, _active$content13, _active$style9, _active$style10, _active$content14, _active$style11, _active$style12, _active$content16, _active$content17, _active$content18, _active$content20, _active$content21, _active$content22, _active$content23, _active$content24, _active$content25, _active$content26, _active$content27, _active$content28, _active$content29, _active$content30, _active$content31, _active$content32, _active$content33, _active$content35, _active$content36, _active$content37, _active$content38, _active$content39, _active$content40, _active$content46, _active$content47, _active$content49, _active$content50, _active$content51, _active$content52, _active$content59, _active$content60, _active$content61, _active$content62, _active$content63, _active$content64, _active$content65, _active$style16, _active$style17, _active$style18, _active$style19, _active$style20, _active$style21, _active$style22, _active$style23, _active$style24, _active$style25, _active$style26, _active$style27, _active$style28, _active$style29, _active$style30, _active$style31, _active$style32, _active$style33, _active$style35, _active$style37, _active$style39, _active$style40, _active$style42, _active$style43, _active$style44, _active$style45, _active$style47, _active$style48, _active$style49, _active$style62, _active$style63, _active$style64, _active$style65, _active$style66, _active$style67, _active$style68, _active$style69, _active$style70, _active$style71, _active$style72;
  var _ref7$viewport = _ref7.viewport,
    viewport = _ref7$viewport === void 0 ? "desktop" : _ref7$viewport,
    active = _ref7.active,
    activeStyle = _ref7.activeStyle,
    selectedElement = _ref7.selectedElement,
    activeRightTab = _ref7.activeRightTab,
    setActiveRightTab = _ref7.setActiveRightTab,
    editText = _ref7.editText,
    editHeadingTag = _ref7.editHeadingTag,
    editCardTitle = _ref7.editCardTitle,
    editButtonLink = _ref7.editButtonLink,
    editButtonTarget = _ref7.editButtonTarget,
    editImageSrc = _ref7.editImageSrc,
    editImageAlt = _ref7.editImageAlt,
    editImageLink = _ref7.editImageLink,
    editHtmlCode = _ref7.editHtmlCode,
    editListItem = _ref7.editListItem,
    removeListItem = _ref7.removeListItem,
    addListItem = _ref7.addListItem,
    editSocialLink = _ref7.editSocialLink,
    editTwoColumnLeft = _ref7.editTwoColumnLeft,
    editTwoColumnRight = _ref7.editTwoColumnRight,
    editThreeColumn = _ref7.editThreeColumn,
    editContentField = _ref7.editContentField,
    editIconBlock = _ref7.editIconBlock,
    removeGalleryImage = _ref7.removeGalleryImage,
    editGalleryImage = _ref7.editGalleryImage,
    handleGalleryImageUpload = _ref7.handleGalleryImageUpload,
    addGalleryImage = _ref7.addGalleryImage,
    removeLogo = _ref7.removeLogo,
    editLogo = _ref7.editLogo,
    handleLogoImageUpload = _ref7.handleLogoImageUpload,
    addLogo = _ref7.addLogo,
    removeAccordionItem = _ref7.removeAccordionItem,
    editAccordionItem = _ref7.editAccordionItem,
    addAccordionItem = _ref7.addAccordionItem,
    removePricingPlan = _ref7.removePricingPlan,
    editPricingPlan = _ref7.editPricingPlan,
    editPricingFeature = _ref7.editPricingFeature,
    removePricingFeature = _ref7.removePricingFeature,
    addPricingFeature = _ref7.addPricingFeature,
    addPricingPlan = _ref7.addPricingPlan,
    removeTestimonial = _ref7.removeTestimonial,
    editTestimonial = _ref7.editTestimonial,
    addTestimonial = _ref7.addTestimonial,
    removeTimelineItem = _ref7.removeTimelineItem,
    editTimelineItem = _ref7.editTimelineItem,
    addTimelineItem = _ref7.addTimelineItem,
    duplicateTimelineItem = _ref7.duplicateTimelineItem,
    editTableHeader = _ref7.editTableHeader,
    editTableCell = _ref7.editTableCell,
    duplicateTableRow = _ref7.duplicateTableRow,
    removeTableRow = _ref7.removeTableRow,
    removeTableColumn = _ref7.removeTableColumn,
    addTableRow = _ref7.addTableRow,
    addTableColumn = _ref7.addTableColumn,
    addLayoutColumn = _ref7.addLayoutColumn,
    duplicateLayoutColumn = _ref7.duplicateLayoutColumn,
    removeLayoutColumn = _ref7.removeLayoutColumn,
    css = _ref7.css,
    applyStylePatch = _ref7.applyStylePatch,
    updateSpacing = _ref7.updateSpacing,
    updateSpacingAll = _ref7.updateSpacingAll,
    toggleSpacingMode = _ref7.toggleSpacingMode,
    updateSize = _ref7.updateSize,
    updateOffset = _ref7.updateOffset,
    updatePosition = _ref7.updatePosition,
    updateZIndex = _ref7.updateZIndex,
    resetResponsiveStyles = _ref7.resetResponsiveStyles,
    updateRadiusCorner = _ref7.updateRadiusCorner,
    updateRadiusAll = _ref7.updateRadiusAll,
    toggleRadiusMode = _ref7.toggleRadiusMode,
    updateColumnBackground = _ref7.updateColumnBackground,
    updateColumnStyleValue = _ref7.updateColumnStyleValue,
    updateColumnStyleValues = _ref7.updateColumnStyleValues,
    updateImageShape = _ref7.updateImageShape,
    remove = _ref7.remove,
    getActiveFontFamily = _ref7.getActiveFontFamily,
    getActiveTextColor = _ref7.getActiveTextColor,
    handleFontChange = _ref7.handleFontChange,
    applyGlobalTextColor = _ref7.applyGlobalTextColor,
    getActiveButtonBackgroundColor = _ref7.getActiveButtonBackgroundColor,
    getActiveButtonTextColor = _ref7.getActiveButtonTextColor,
    applyGlobalButtonBackgroundColor = _ref7.applyGlobalButtonBackgroundColor,
    applyGlobalButtonTextColor = _ref7.applyGlobalButtonTextColor,
    getActiveBackgroundColor = _ref7.getActiveBackgroundColor,
    applyGlobalBackgroundColor = _ref7.applyGlobalBackgroundColor,
    getActiveBackgroundImage = _ref7.getActiveBackgroundImage,
    setGlobalBackgroundImageUrl = _ref7.setGlobalBackgroundImageUrl,
    handleGlobalBackgroundImageUpload = _ref7.handleGlobalBackgroundImageUpload,
    _ref7$documentPadding = _ref7.documentPadding,
    documentPadding = _ref7$documentPadding === void 0 ? 30 : _ref7$documentPadding,
    setDocumentPadding = _ref7.setDocumentPadding,
    _ref7$documentPageSiz = _ref7.documentPageSize,
    documentPageSize = _ref7$documentPageSiz === void 0 ? "auto" : _ref7$documentPageSiz,
    setDocumentPageSize = _ref7.setDocumentPageSize,
    _ref7$showSafeArea = _ref7.showSafeArea,
    showSafeArea = _ref7$showSafeArea === void 0 ? false : _ref7$showSafeArea,
    setShowSafeArea = _ref7.setShowSafeArea,
    _ref7$showGrid = _ref7.showGrid,
    showGrid = _ref7$showGrid === void 0 ? false : _ref7$showGrid,
    setShowGrid = _ref7.setShowGrid,
    handleBackgroundImageUpload = _ref7.handleBackgroundImageUpload,
    setBackgroundImageUrl = _ref7.setBackgroundImageUrl,
    imageUploading = _ref7.imageUploading,
    imageUploadError = _ref7.imageUploadError,
    handleImageSrcUpload = _ref7.handleImageSrcUpload,
    _ref7$showSavedTempla = _ref7.showSavedTemplates,
    showSavedTemplates = _ref7$showSavedTempla === void 0 ? false : _ref7$showSavedTempla,
    _ref7$savedTemplates = _ref7.savedTemplates,
    savedTemplates = _ref7$savedTemplates === void 0 ? [] : _ref7$savedTemplates,
    _ref7$savedTemplatesL = _ref7.savedTemplatesLoading,
    savedTemplatesLoading = _ref7$savedTemplatesL === void 0 ? false : _ref7$savedTemplatesL,
    onSelectSavedTemplate = _ref7.onSelectSavedTemplate,
    _ref7$isCompact = _ref7.isCompact,
    isCompact = _ref7$isCompact === void 0 ? false : _ref7$isCompact,
    _ref7$panelWidth = _ref7.panelWidth,
    panelWidth = _ref7$panelWidth === void 0 ? 320 : _ref7$panelWidth,
    _ref7$isExpanded = _ref7.isExpanded,
    isExpanded = _ref7$isExpanded === void 0 ? true : _ref7$isExpanded,
    onExpand = _ref7.onExpand,
    onCollapse = _ref7.onCollapse;
  var styleTarget = (_ref8 = activeStyle !== null && activeStyle !== void 0 ? activeStyle : active === null || active === void 0 ? void 0 : active.style) !== null && _ref8 !== void 0 ? _ref8 : {};
  var isElementStyleMode = Boolean(active && selectedElement);
  var elementPartLabel = active && selectedElement ? resolveElementPartLabel(active.type, selectedElement) : null;
  var elementOnlyStyle = isElementStyleMode && active !== null && active !== void 0 && (_active$elementStyles = active.elementStyles) !== null && _active$elementStyles !== void 0 && _active$elementStyles[selectedElement] ? active.elementStyles[selectedElement] : {};
  var _useState5 = useState("all"),
    _useState6 = _slicedToArray(_useState5, 2),
    activeColumnFilter = _useState6[0],
    setActiveColumnFilter = _useState6[1];
  var _useState7 = useState({}),
    _useState8 = _slicedToArray(_useState7, 2),
    collapsedColumns = _useState8[0],
    setCollapsedColumns = _useState8[1];
  useEffect(function () {
    setActiveColumnFilter("all");
    setCollapsedColumns({});
  }, [active === null || active === void 0 ? void 0 : active.id]);
  var openRightTab = function openRightTab(tabId) {
    var isDesignClick = tabId !== "saved-templates";
    var currentlyOnDesign = activeRightTab !== "saved-templates";
    if (isCompact && isExpanded) {
      if (isDesignClick && currentlyOnDesign || !isDesignClick && activeRightTab === "saved-templates") {
        if (onCollapse) onCollapse();
        return;
      }
    }
    setActiveRightTab(tabId);
    if (isCompact && onExpand) onExpand();
  };
  var railButtonStyle = function railButtonStyle(isActive) {
    return {
      width: 40,
      height: 40,
      border: "none",
      borderRadius: 8,
      background: isActive ? "#101828" : "transparent",
      color: isActive ? "#ffffff" : "#64748b",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      padding: 0,
      transition: "all 0.15s ease"
    };
  };
  var designTabActive = isExpanded && activeRightTab !== "saved-templates";
  var templatesTabActive = isExpanded && activeRightTab === "saved-templates";
  var rail = isCompact ? /*#__PURE__*/_jsxs("div", {
    className: "ws-builder-properties-rail",
    style: {
      width: 56,
      flexShrink: 0,
      background: UI.panel,
      borderLeft: "1px solid ".concat(UI.panelBorder),
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: "12px 0",
      gap: 8,
      boxSizing: "border-box",
      zIndex: 20
    },
    children: [/*#__PURE__*/_jsx("button", {
      type: "button",
      title: "Design",
      "aria-label": "Design",
      onClick: function onClick() {
        return openRightTab(active ? "content" : "global");
      },
      style: railButtonStyle(designTabActive),
      onMouseEnter: function onMouseEnter(e) {
        if (!designTabActive) {
          e.currentTarget.style.background = "#f1f5f9";
          e.currentTarget.style.color = "#0f172a";
        }
      },
      onMouseLeave: function onMouseLeave(e) {
        if (!designTabActive) {
          e.currentTarget.style.background = "transparent";
          e.currentTarget.style.color = "#64748b";
        }
      },
      children: /*#__PURE__*/_jsx(BuilderIcon, {
        name: "settings",
        size: 18,
        color: "currentColor"
      })
    }), showSavedTemplates && /*#__PURE__*/_jsx("button", {
      type: "button",
      title: "Templates",
      "aria-label": "Templates",
      onClick: function onClick() {
        return openRightTab("saved-templates");
      },
      style: railButtonStyle(templatesTabActive),
      onMouseEnter: function onMouseEnter(e) {
        if (!templatesTabActive) {
          e.currentTarget.style.background = "#f1f5f9";
          e.currentTarget.style.color = "#0f172a";
        }
      },
      onMouseLeave: function onMouseLeave(e) {
        if (!templatesTabActive) {
          e.currentTarget.style.background = "transparent";
          e.currentTarget.style.color = "#64748b";
        }
      },
      children: /*#__PURE__*/_jsx(BuilderIcon, {
        name: "templates",
        size: 18,
        color: "currentColor"
      })
    })]
  }) : null;
  if (isCompact && !isExpanded) {
    return rail;
  }
  var panelBody = /*#__PURE__*/_jsxs("div", {
    className: "ws-builder-properties",
    style: {
      width: isCompact ? 320 : panelWidth,
      maxWidth: "100%",
      background: UI.panel,
      borderLeft: "1px solid ".concat(UI.panelBorder),
      padding: 0,
      boxSizing: "border-box",
      overflowY: "auto",
      display: "flex",
      flexDirection: "column",
      height: "100%",
      boxShadow: isCompact ? "-8px 0 24px rgba(15, 23, 42, 0.12)" : "none"
    },
    children: [/*#__PURE__*/_jsxs("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        gap: 20,
        padding: "20px 20px 0px 20px"
      },
      children: [/*#__PURE__*/_jsxs("div", {
        style: {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 8
        },
        children: [/*#__PURE__*/_jsx("h3", {
          style: {
            fontSize: 16,
            fontWeight: 600,
            textTransform: "uppercase",
            letterSpacing: "0.05em",
            color: '#101828',
            margin: 0,
            flex: 1,
            minWidth: 0
          },
          children: activeRightTab === "saved-templates" ? "Templates" : active && activeRightTab !== "global" ? "".concat((((_active$content = active.content) === null || _active$content === void 0 ? void 0 : _active$content.sectionLabel) || active.type).toUpperCase()).concat(elementPartLabel ? " \u2014 ".concat(elementPartLabel) : "", " Settings") : "Global Styling"
        }), isCompact && /*#__PURE__*/_jsx("button", {
          type: "button",
          title: "Close",
          "aria-label": "Close panel",
          onClick: function onClick() {
            return onCollapse && onCollapse();
          },
          style: _objectSpread(_objectSpread({}, railButtonStyle(false)), {}, {
            width: 36,
            height: 36,
            flexShrink: 0
          }),
          children: /*#__PURE__*/_jsx(BuilderIcon, {
            name: "close",
            size: 16,
            color: "currentColor"
          })
        })]
      }), active && viewport !== "desktop" && /*#__PURE__*/_jsxs("div", {
        style: {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 8
        },
        children: [/*#__PURE__*/_jsxs("span", {
          style: {
            background: "#eef2ff",
            color: "#3730a3",
            borderRadius: 999,
            padding: "4px 8px",
            fontSize: 10,
            fontWeight: 700,
            textTransform: "uppercase"
          },
          children: ["Editing ", viewport, " override"]
        }), /*#__PURE__*/_jsx("button", {
          type: "button",
          onClick: resetResponsiveStyles,
          style: {
            border: "1px solid #d1d5db",
            background: "#ffffff",
            borderRadius: 6,
            padding: "4px 7px",
            fontSize: 10,
            cursor: "pointer",
            color: "#475569"
          },
          children: "Reset"
        })]
      })]
    }), active ? /*#__PURE__*/_jsxs("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        gap: 0
      },
      children: [/*#__PURE__*/_jsxs("div", {
        style: {
          display: "flex",
          alignItems: "stretch",
          marginTop: 16,
          padding: "0 16px",
          borderBottom: "1px solid ".concat(UI.panelBorder)
        },
        children: [/*#__PURE__*/_jsx("button", {
          type: "button",
          onClick: function onClick() {
            return setActiveRightTab("content");
          },
          style: rightPanelTabStyle(activeRightTab === "content"),
          children: "Content"
        }), /*#__PURE__*/_jsx("button", {
          type: "button",
          onClick: function onClick() {
            return setActiveRightTab("style");
          },
          style: rightPanelTabStyle(activeRightTab === "style"),
          children: "Style"
        }), /*#__PURE__*/_jsx("button", {
          type: "button",
          onClick: function onClick() {
            return setActiveRightTab("global");
          },
          style: rightPanelTabStyle(activeRightTab === "global"),
          children: "Global"
        }), showSavedTemplates && /*#__PURE__*/_jsx("button", {
          type: "button",
          onClick: function onClick() {
            return setActiveRightTab("saved-templates");
          },
          style: rightPanelTabStyle(activeRightTab === "saved-templates"),
          title: "Templates",
          children: "Templates"
        })]
      }), /*#__PURE__*/_jsxs("div", {
        children: [activeRightTab === "content" && /*#__PURE__*/_jsxs("div", {
          style: {
            display: "flex",
            flexDirection: "column",
            gap: 20,
            padding: 20
          },
          children: [active.type !== "divider" && active.type !== "page-break" && active.type !== "group" && active.type !== "html" && active.type !== "list" && active.type !== "spacer" && active.type !== "social" && active.type !== "table" && active.type !== "one-column" && active.type !== "two-column" && active.type !== "three-column" && active.type !== "image" && active.type !== "quote" && active.type !== "gallery" && active.type !== "cta" && active.type !== "logos" && active.type !== "accordion" && active.type !== "pricing" && active.type !== "testimonials" && active.type !== "text-banner" && active.type !== "icon" && active.type !== "card" && active.type !== "signature" && active.type !== "timeline" && active.type !== "cover" && /*#__PURE__*/_jsxs("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: 8
            },
            children: [/*#__PURE__*/_jsx("label", {
              style: {
                fontSize: 14,
                fontWeight: 500,
                color: "#4b5563"
              },
              children: "Text Label"
            }), /*#__PURE__*/_jsx("textarea", {
              rows: active.type === "text" ? 4 : 4,
              value: ((_active$content2 = active.content) === null || _active$content2 === void 0 ? void 0 : _active$content2.text) || "",
              onChange: function onChange(e) {
                return editText(e.target.value);
              },
              style: {
                width: "100%",
                background: "#ffffff",
                border: "1px solid #d1d5db",
                fontFamily: "DM Sans, sans-serif",
                fontWeight: 500,
                borderRadius: 6,
                color: "#374151",
                padding: "8px 12px",
                fontSize: 14,
                outline: "none",
                resize: "vertical",
                boxSizing: "border-box"
              }
            })]
          }), active.type === "heading" && /*#__PURE__*/_jsxs("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: 8
            },
            children: [/*#__PURE__*/_jsx("label", {
              style: {
                fontSize: 14,
                fontWeight: 500,
                color: "#4b5563"
              },
              children: "Heading Tag"
            }), /*#__PURE__*/_jsxs("select", {
              value: ((_active$content3 = active.content) === null || _active$content3 === void 0 ? void 0 : _active$content3.tag) || "h1",
              onChange: function onChange(e) {
                return editHeadingTag(e.target.value);
              },
              style: {
                width: "100%",
                background: "#ffffff",
                border: "1px solid #d1d5db",
                borderRadius: 6,
                color: "#374151",
                padding: "8px 12px",
                fontSize: 14,
                outline: "none",
                boxSizing: "border-box"
              },
              children: [/*#__PURE__*/_jsx("option", {
                value: "h1",
                children: "H1"
              }), /*#__PURE__*/_jsx("option", {
                value: "h2",
                children: "H2"
              }), /*#__PURE__*/_jsx("option", {
                value: "h3",
                children: "H3"
              }), /*#__PURE__*/_jsx("option", {
                value: "h4",
                children: "H4"
              }), /*#__PURE__*/_jsx("option", {
                value: "h5",
                children: "H5"
              }), /*#__PURE__*/_jsx("option", {
                value: "h6",
                children: "H6"
              })]
            })]
          }), active.type === "card" && /*#__PURE__*/_jsxs("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: 14
            },
            children: [/*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 8
              },
              children: [/*#__PURE__*/_jsx("label", {
                style: {
                  fontSize: 13,
                  fontWeight: 500,
                  color: "#4b5563"
                },
                children: "Card Title"
              }), /*#__PURE__*/_jsx("input", {
                type: "text",
                value: ((_active$content4 = active.content) === null || _active$content4 === void 0 ? void 0 : _active$content4.title) || "",
                onChange: function onChange(e) {
                  return editCardTitle(e.target.value);
                },
                style: {
                  width: "100%",
                  background: "#ffffff",
                  border: "1px solid #d1d5db",
                  borderRadius: 6,
                  color: "#374151",
                  padding: "8px 12px",
                  fontSize: 14,
                  outline: "none",
                  boxSizing: "border-box"
                }
              })]
            }), /*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 8
              },
              children: [/*#__PURE__*/_jsx("label", {
                style: {
                  fontSize: 13,
                  fontWeight: 500,
                  color: "#4b5563"
                },
                children: "Card Description"
              }), /*#__PURE__*/_jsx("textarea", {
                rows: 4,
                value: ((_active$content5 = active.content) === null || _active$content5 === void 0 ? void 0 : _active$content5.text) || "",
                onChange: function onChange(e) {
                  return editText(e.target.value);
                },
                style: {
                  width: "100%",
                  background: "#ffffff",
                  border: "1px solid #d1d5db",
                  borderRadius: 6,
                  color: "#374151",
                  padding: "8px 12px",
                  fontSize: 14,
                  outline: "none",
                  resize: "vertical",
                  boxSizing: "border-box"
                }
              })]
            })]
          }), active.type === "button" && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 8
              },
              children: [/*#__PURE__*/_jsx("label", {
                style: {
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#4b5563"
                },
                children: "Button Link URL"
              }), /*#__PURE__*/_jsx("input", {
                type: "text",
                value: ((_active$content6 = active.content) === null || _active$content6 === void 0 ? void 0 : _active$content6.url) || "",
                onChange: function onChange(e) {
                  return editButtonLink(e.target.value);
                },
                placeholder: "https://example.com",
                style: {
                  width: "100%",
                  background: "#ffffff",
                  border: "1px solid #d1d5db",
                  borderRadius: 6,
                  color: "#374151",
                  padding: "8px 12px",
                  fontFamily: "DM Sans, sans-serif",
                  fontWeight: 500,
                  fontSize: 14,
                  outline: "none",
                  boxSizing: "border-box"
                }
              })]
            }), /*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 8
              },
              children: [/*#__PURE__*/_jsx("label", {
                style: {
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#4b5563"
                },
                children: "Open Link In"
              }), /*#__PURE__*/_jsxs("select", {
                value: ((_active$content7 = active.content) === null || _active$content7 === void 0 ? void 0 : _active$content7.target) || "_blank",
                onChange: function onChange(e) {
                  return editButtonTarget(e.target.value);
                },
                style: {
                  width: "100%",
                  background: "#ffffff",
                  border: "1px solid #d1d5db",
                  borderRadius: 6,
                  color: "#374151",
                  padding: "8px 12px",
                  outline: "none",
                  boxSizing: "border-box",
                  fontFamily: "DM Sans, sans-serif",
                  fontWeight: 500,
                  fontSize: 14
                },
                children: [/*#__PURE__*/_jsx("option", {
                  value: "_blank",
                  children: "New Tab"
                }), /*#__PURE__*/_jsx("option", {
                  value: "_self",
                  children: "Same Tab"
                })]
              })]
            })]
          }), active.type === "image" && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(ImageUploadField, {
              label: "Image",
              value: ((_active$content8 = active.content) === null || _active$content8 === void 0 ? void 0 : _active$content8.src) || "",
              onUrlChange: editImageSrc,
              onFileChange: handleImageSrcUpload,
              uploading: imageUploading === "image-src",
              onRemove: function onRemove() {
                return editImageSrc("");
              },
              error: (imageUploadError === null || imageUploadError === void 0 ? void 0 : imageUploadError.key) === "image-src" ? imageUploadError.message : null
            }), /*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 8
              },
              children: [/*#__PURE__*/_jsxs("div", {
                style: {
                  display: "flex",
                  justifyContent: "space-between",
                  fontSize: 14,
                  fontWeight: 500
                },
                children: [/*#__PURE__*/_jsx("span", {
                  style: {
                    color: "#4b5563"
                  },
                  children: "Image Width"
                }), /*#__PURE__*/_jsx("span", {
                  style: {
                    color: "#64748b"
                  },
                  children: ((_active$style = active.style) === null || _active$style === void 0 ? void 0 : _active$style.width) || "100%"
                })]
              }), /*#__PURE__*/_jsx("input", {
                type: "range",
                min: "10",
                max: "100",
                value: parseInt((_active$style2 = active.style) === null || _active$style2 === void 0 ? void 0 : _active$style2.width) || 100,
                onChange: function onChange(e) {
                  return css("width", e.target.value + "%");
                },
                style: {
                  width: "100%",
                  cursor: "pointer",
                  accentColor: "#101828"
                }
              })]
            }), /*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 8
              },
              children: [/*#__PURE__*/_jsx("label", {
                style: {
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#4b5563"
                },
                children: "Image Shape"
              }), /*#__PURE__*/_jsx("div", {
                style: {
                  display: "flex",
                  gap: 10
                },
                children: [{
                  id: "rectangle",
                  label: "Rectangle"
                }, {
                  id: "circle",
                  label: "Circle"
                }].map(function (shape) {
                  var _active$style3;
                  var activeShape = ((_active$style3 = active.style) === null || _active$style3 === void 0 ? void 0 : _active$style3.imageShape) === "circle" ? "circle" : "rectangle";
                  var isActive = activeShape === shape.id;
                  return /*#__PURE__*/_jsxs("button", {
                    type: "button",
                    onClick: function onClick() {
                      return updateImageShape(shape.id);
                    },
                    style: {
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 8,
                      border: "none",
                      flex: 1,
                      background: isActive ? "#101828" : "#f2f4f7",
                      color: isActive ? "#ffffff" : "#101828",
                      borderRadius: 8,
                      height: 40,
                      fontSize: 13,
                      fontWeight: 600,
                      cursor: "pointer",
                      transition: "all 0.15s"
                    },
                    children: [/*#__PURE__*/_jsx("span", {
                      style: {
                        width: 16,
                        height: 16,
                        border: "2px solid ".concat(isActive ? "#ffffff" : "#101828"),
                        borderRadius: shape.id === "circle" ? "50%" : 3,
                        background: "transparent",
                        flexShrink: 0
                      }
                    }), shape.label]
                  }, shape.id);
                })
              })]
            }), /*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 10
              },
              children: [/*#__PURE__*/_jsx("label", {
                style: {
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#4b5563"
                },
                children: "Crop & Focal Point"
              }), /*#__PURE__*/_jsxs("select", {
                value: ((_active$style4 = active.style) === null || _active$style4 === void 0 ? void 0 : _active$style4.objectFit) || (((_active$style5 = active.style) === null || _active$style5 === void 0 ? void 0 : _active$style5.imageShape) === "circle" ? "cover" : "contain"),
                onChange: function onChange(e) {
                  return css("objectFit", e.target.value);
                },
                style: _objectSpread(_objectSpread({}, panelFieldStyle), {}, {
                  padding: "7px 10px",
                  cursor: "pointer"
                }),
                children: [/*#__PURE__*/_jsx("option", {
                  value: "cover",
                  children: "Cover (crop)"
                }), /*#__PURE__*/_jsx("option", {
                  value: "contain",
                  children: "Contain (show full image)"
                }), /*#__PURE__*/_jsx("option", {
                  value: "fill",
                  children: "Fill (stretch)"
                }), /*#__PURE__*/_jsx("option", {
                  value: "none",
                  children: "Original size"
                })]
              }), ["X", "Y"].map(function (axis) {
                var _active$style6;
                var position = String(((_active$style6 = active.style) === null || _active$style6 === void 0 ? void 0 : _active$style6.objectPosition) || "50% 50%").split(/\s+/);
                var current = parseInt(position[axis === "X" ? 0 : 1], 10) || 50;
                return /*#__PURE__*/_jsxs("div", {
                  style: {
                    display: "flex",
                    flexDirection: "column",
                    gap: 4
                  },
                  children: [/*#__PURE__*/_jsxs("div", {
                    style: {
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: 12,
                      color: "#64748b"
                    },
                    children: [/*#__PURE__*/_jsxs("span", {
                      children: ["Focal ", axis]
                    }), /*#__PURE__*/_jsxs("span", {
                      children: [current, "%"]
                    })]
                  }), /*#__PURE__*/_jsx("input", {
                    type: "range",
                    min: "0",
                    max: "100",
                    value: current,
                    onChange: function onChange(e) {
                      var next = _toConsumableArray(position);
                      next[axis === "X" ? 0 : 1] = "".concat(e.target.value, "%");
                      css("objectPosition", "".concat(next[0] || "50%", " ").concat(next[1] || "50%"));
                    },
                    style: {
                      width: "100%",
                      cursor: "pointer",
                      accentColor: "#101828"
                    }
                  })]
                }, axis);
              })]
            }), /*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 8
              },
              children: [/*#__PURE__*/_jsx("label", {
                style: {
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#4b5563"
                },
                children: "Image Alignment"
              }), /*#__PURE__*/_jsx("div", {
                style: {
                  display: "flex",
                  gap: 10
                },
                children: ["left", "center", "right"].map(function (align) {
                  var _active$style7, _active$style8;
                  return /*#__PURE__*/_jsx("button", {
                    type: "button",
                    onClick: function onClick() {
                      return css("textAlign", align);
                    },
                    style: {
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border: "none",
                      flex: '0 0 auto',
                      background: (((_active$style7 = active.style) === null || _active$style7 === void 0 ? void 0 : _active$style7.textAlign) || "center") === align ? "#101828" : "#f2f4f7",
                      color: (((_active$style8 = active.style) === null || _active$style8 === void 0 ? void 0 : _active$style8.textAlign) || "center") === align ? "#ffffff" : "#101828",
                      borderRadius: 40,
                      width: 40,
                      height: 40,
                      fontSize: 14,
                      fontWeight: 600,
                      cursor: "pointer",
                      textTransform: "capitalize",
                      transition: "all 0.15s"
                    },
                    children: /*#__PURE__*/_jsx(BuilderIcon, {
                      name: align === "left" ? "align-left" : align === "center" ? "align-center" : "align-right",
                      size: 20
                    })
                  }, align);
                })
              })]
            }), /*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 8
              },
              children: [/*#__PURE__*/_jsx("label", {
                style: {
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#4b5563"
                },
                children: "Alt Text Description"
              }), /*#__PURE__*/_jsx("input", {
                type: "text",
                value: ((_active$content9 = active.content) === null || _active$content9 === void 0 ? void 0 : _active$content9.alt) || "",
                onChange: function onChange(e) {
                  return editImageAlt(e.target.value);
                },
                placeholder: "Accessible image desc",
                style: {
                  width: "100%",
                  background: "#ffffff",
                  border: "1px solid #d1d5db",
                  fontFamily: "DM Sans, sans-serif",
                  fontWeight: 500,
                  borderRadius: 6,
                  color: "#374151",
                  padding: "8px 12px",
                  fontSize: 14,
                  outline: "none",
                  boxSizing: "border-box"
                }
              })]
            }), /*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 8
              },
              children: [/*#__PURE__*/_jsx("label", {
                style: {
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#4b5563"
                },
                children: "Redirect URL (optional)"
              }), /*#__PURE__*/_jsx("input", {
                type: "text",
                value: ((_active$content10 = active.content) === null || _active$content10 === void 0 ? void 0 : _active$content10.url) || "",
                onChange: function onChange(e) {
                  return editImageLink(e.target.value);
                },
                placeholder: "Link on image click",
                style: {
                  width: "100%",
                  background: "#ffffff",
                  border: "1px solid #d1d5db",
                  fontFamily: "DM Sans, sans-serif",
                  fontWeight: 500,
                  borderRadius: 6,
                  color: "#374151",
                  padding: "8px 12px",
                  fontSize: 14,
                  outline: "none",
                  boxSizing: "border-box"
                }
              })]
            })]
          }), active.type === "html" && /*#__PURE__*/_jsxs("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: 8
            },
            children: [/*#__PURE__*/_jsx("label", {
              style: {
                fontSize: 14,
                fontWeight: 500,
                color: "#4b5563"
              },
              children: "Raw HTML Code"
            }), /*#__PURE__*/_jsx("textarea", {
              rows: 8,
              value: ((_active$content11 = active.content) === null || _active$content11 === void 0 ? void 0 : _active$content11.code) || "",
              onChange: function onChange(e) {
                return editHtmlCode(e.target.value);
              },
              style: {
                width: "100%",
                background: "#ffffff",
                border: "1px solid #d1d5db",
                borderRadius: 6,
                color: "#374151",
                padding: "8px 12px",
                fontFamily: "monospace",
                fontSize: 12,
                outline: "none",
                resize: "vertical",
                boxSizing: "border-box"
              }
            })]
          }), active.type === "list" && /*#__PURE__*/_jsxs("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: 10
            },
            children: [/*#__PURE__*/_jsx("label", {
              style: {
                fontSize: 14,
                fontWeight: 500,
                color: "#4b5563"
              },
              children: "List Style"
            }), /*#__PURE__*/_jsxs("select", {
              value: ((_active$content12 = active.content) === null || _active$content12 === void 0 ? void 0 : _active$content12.listStyle) || "check",
              onChange: function onChange(e) {
                return editContentField("listStyle", e.target.value);
              },
              style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
                fontFamily: "DM Sans, sans-serif",
                fontSize: 14,
                fontWeight: 500,
                color: "#4b5563",
                cursor: "pointer",
                padding: "6px 10px"
              }),
              children: [/*#__PURE__*/_jsx("option", {
                value: "check",
                children: "\u2713 Checkmark"
              }), /*#__PURE__*/_jsx("option", {
                value: "bullet",
                children: "\u2022 Bullet Point"
              }), /*#__PURE__*/_jsx("option", {
                value: "number",
                children: "1. 2. 3. Numbers"
              }), /*#__PURE__*/_jsx("option", {
                value: "alpha",
                children: "a. b. c. Alphabets"
              })]
            }), (((_active$content13 = active.content) === null || _active$content13 === void 0 ? void 0 : _active$content13.listStyle) || "check") === "check" && /*#__PURE__*/_jsx(ColorPickerField, {
              label: "Checkmark Color",
              value: ((_active$style9 = active.style) === null || _active$style9 === void 0 ? void 0 : _active$style9.markerColor) || ((_active$style10 = active.style) === null || _active$style10 === void 0 ? void 0 : _active$style10.color) || "#10b981",
              onChange: function onChange(val) {
                return css("markerColor", val);
              }
            }), /*#__PURE__*/_jsx("label", {
              style: {
                fontSize: 14,
                fontWeight: 500,
                color: "#4b5563"
              },
              children: "Feature Items"
            }), (((_active$content14 = active.content) === null || _active$content14 === void 0 ? void 0 : _active$content14.items) || []).map(function (item, idx) {
              return /*#__PURE__*/_jsxs("div", {
                style: {
                  display: "flex",
                  gap: 6
                },
                children: [/*#__PURE__*/_jsx("input", {
                  type: "text",
                  value: item,
                  onChange: function onChange(e) {
                    return editListItem(idx, e.target.value);
                  },
                  style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
                    fontFamily: "DM Sans, sans-serif",
                    fontWeight: 500,
                    fontSize: 14
                  })
                }), /*#__PURE__*/_jsx("button", {
                  onClick: function onClick() {
                    return removeListItem(idx);
                  },
                  style: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 36,
                    height: 36,
                    background: "#ef4444",
                    color: "#ffffff",
                    border: "none",
                    borderRadius: 6,
                    cursor: "pointer",
                    fontSize: 12
                  },
                  children: /*#__PURE__*/_jsx(BuilderIcon, {
                    name: "delete",
                    size: 18
                  })
                })]
              }, idx);
            }), /*#__PURE__*/_jsxs("button", {
              onClick: addListItem,
              style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 8,
                background: '#101828',
                color: '#ffffff',
                border: 'none',
                borderRadius: 6,
                padding: "10px 20px",
                fontFamily: "DM Sans, sans-serif",
                fontSize: 14,
                fontWeight: 500,
                cursor: "pointer",
                marginTop: 4
              },
              children: [/*#__PURE__*/_jsx(BuilderIcon, {
                name: "add",
                size: 18
              }), "Add Feature Item"]
            })]
          }), active.type === "spacer" && /*#__PURE__*/_jsxs("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: 8
            },
            children: [/*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                justifyContent: "space-between",
                fontSize: 14,
                fontWeight: 500
              },
              children: [/*#__PURE__*/_jsx("span", {
                style: {
                  color: "#4b5563"
                },
                children: "Spacer Height"
              }), /*#__PURE__*/_jsx("span", {
                style: {
                  color: "#64748b"
                },
                children: ((_active$style11 = active.style) === null || _active$style11 === void 0 ? void 0 : _active$style11.height) || "40px"
              })]
            }), /*#__PURE__*/_jsx("input", {
              type: "range",
              min: "10",
              max: "150",
              value: parseInt((_active$style12 = active.style) === null || _active$style12 === void 0 ? void 0 : _active$style12.height) || 40,
              onChange: function onChange(e) {
                return css("height", e.target.value + "px");
              },
              style: {
                width: "100%",
                cursor: "pointer",
                accentColor: "#101828"
              }
            })]
          }), active.type === "social" && /*#__PURE__*/_jsxs("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: 12
            },
            children: [/*#__PURE__*/_jsx("label", {
              style: {
                fontSize: 14,
                fontWeight: 500,
                color: "#4b5563"
              },
              children: "Social Media Links"
            }), ["facebook", "twitter", "linkedin", "instagram"].map(function (net) {
              var _active$content15;
              return /*#__PURE__*/_jsxs("div", {
                style: {
                  display: "flex",
                  flexDirection: "column",
                  gap: 4
                },
                children: [/*#__PURE__*/_jsxs("span", {
                  style: {
                    fontSize: 13,
                    textTransform: "capitalize",
                    color: "#6b7280"
                  },
                  children: [net, " URL"]
                }), /*#__PURE__*/_jsx("input", {
                  type: "text",
                  value: ((_active$content15 = active.content) === null || _active$content15 === void 0 ? void 0 : _active$content15[net]) || "",
                  onChange: function onChange(e) {
                    return editSocialLink(net, e.target.value);
                  },
                  placeholder: "#",
                  style: {
                    width: "100%",
                    background: "#ffffff",
                    border: "1px solid #475569",
                    borderRadius: 6,
                    color: "#101828",
                    padding: "8px 10px",
                    fontFamily: "DM Sans, sans-serif",
                    fontWeight: 500,
                    fontSize: 14,
                    outline: "none",
                    boxSizing: "border-box"
                  }
                })]
              }, net);
            })]
          }), active.type === "one-column" && !isNestedColumnContent(active.content) && /*#__PURE__*/_jsxs("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: 8
            },
            children: [/*#__PURE__*/_jsx("label", {
              style: {
                fontSize: 14,
                fontWeight: 500,
                color: "#4b5563"
              },
              children: "Column Content"
            }), /*#__PURE__*/_jsx("textarea", {
              rows: 3,
              value: ((_active$content16 = active.content) === null || _active$content16 === void 0 ? void 0 : _active$content16.col1) || "",
              onChange: function onChange(e) {
                return editThreeColumn("col1", e.target.value);
              },
              style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
                fontFamily: "DM Sans, sans-serif",
                fontWeight: 500,
                fontSize: 14
              }),
              placeholder: "Column Content"
            })]
          }), active.type === "two-column" && !isNestedColumnContent(active.content) && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 8
              },
              children: [/*#__PURE__*/_jsx("label", {
                style: {
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#4b5563"
                },
                children: "Left Column"
              }), /*#__PURE__*/_jsx("textarea", {
                rows: 3,
                value: ((_active$content17 = active.content) === null || _active$content17 === void 0 ? void 0 : _active$content17.leftText) || "",
                onChange: function onChange(e) {
                  return editTwoColumnLeft(e.target.value);
                },
                style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
                  fontFamily: "DM Sans, sans-serif",
                  fontWeight: 500,
                  fontSize: 14
                }),
                placeholder: "Left Column Content"
              })]
            }), /*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 8,
                marginTop: 10
              },
              children: [/*#__PURE__*/_jsx("label", {
                style: {
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#4b5563"
                },
                children: "Right Column"
              }), /*#__PURE__*/_jsx("textarea", {
                rows: 3,
                value: ((_active$content18 = active.content) === null || _active$content18 === void 0 ? void 0 : _active$content18.rightText) || "",
                onChange: function onChange(e) {
                  return editTwoColumnRight(e.target.value);
                },
                style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
                  fontFamily: "DM Sans, sans-serif",
                  fontWeight: 500,
                  fontSize: 14
                }),
                placeholder: "Right Column Content"
              })]
            })]
          }), active.type === "three-column" && !isNestedColumnContent(active.content) && /*#__PURE__*/_jsx(_Fragment, {
            children: ["col1", "col2", "col3"].map(function (col, idx) {
              var _active$content19;
              return /*#__PURE__*/_jsxs("div", {
                style: {
                  display: "flex",
                  flexDirection: "column",
                  gap: 8
                },
                children: [/*#__PURE__*/_jsxs("label", {
                  style: {
                    fontSize: 14,
                    fontWeight: 500,
                    color: "#4b5563"
                  },
                  children: ["Column ", idx + 1, " Text"]
                }), /*#__PURE__*/_jsx("textarea", {
                  rows: 3,
                  value: ((_active$content19 = active.content) === null || _active$content19 === void 0 ? void 0 : _active$content19[col]) || "",
                  onChange: function onChange(e) {
                    return editThreeColumn(col, e.target.value);
                  },
                  style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
                    fontFamily: "DM Sans, sans-serif",
                    fontWeight: 500,
                    fontSize: 14
                  })
                })]
              }, col);
            })
          }), isColumnLayoutType(active.type) && /*#__PURE__*/_jsxs("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: 12
            },
            children: [isNestedColumnContent(active.content) && /*#__PURE__*/_jsx("p", {
              style: {
                margin: 0,
                fontSize: 13,
                color: "#64748b",
                lineHeight: 1.5
              },
              children: "Drag blocks from the sidebar into each column on the canvas. Blocks inside columns can be reordered, edited, and styled individually."
            }), function () {
              var colCount = isNestedColumnContent(active.content) ? getLayoutColumnCount(active.content, active.type === "three-column" ? 3 : active.type === "one-column" ? 1 : 2) : active.type === "three-column" ? 3 : active.type === "one-column" ? 1 : 2;
              var canRemove = colCount > MIN_LAYOUT_COLUMNS;
              var canDuplicate = colCount < MAX_LAYOUT_COLUMNS;
              return /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsxs("div", {
                  style: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 8
                  },
                  children: [/*#__PURE__*/_jsxs("span", {
                    style: {
                      fontSize: 14,
                      fontWeight: 600,
                      color: "#101828"
                    },
                    children: ["Columns (", colCount, "/", MAX_LAYOUT_COLUMNS, ")"]
                  }), /*#__PURE__*/_jsxs("button", {
                    type: "button",
                    onClick: addLayoutColumn,
                    disabled: colCount >= MAX_LAYOUT_COLUMNS,
                    style: {
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 4,
                      background: colCount >= MAX_LAYOUT_COLUMNS ? "#e2e8f0" : "#101828",
                      color: colCount >= MAX_LAYOUT_COLUMNS ? "#94a3b8" : "#ffffff",
                      border: "none",
                      borderRadius: 6,
                      padding: "4px 10px",
                      fontFamily: "DM Sans, sans-serif",
                      fontWeight: 500,
                      fontSize: 12,
                      cursor: colCount >= MAX_LAYOUT_COLUMNS ? "not-allowed" : "pointer"
                    },
                    title: "Add column",
                    children: [/*#__PURE__*/_jsx(BuilderIcon, {
                      name: "add",
                      size: 14
                    }), "Add Column"]
                  })]
                }), /*#__PURE__*/_jsxs("div", {
                  style: {
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    flexWrap: "wrap",
                    margin: "2px 0 6px 0"
                  },
                  children: [/*#__PURE__*/_jsx("button", {
                    type: "button",
                    onClick: function onClick() {
                      return setActiveColumnFilter("all");
                    },
                    style: {
                      padding: "4px 10px",
                      borderRadius: 999,
                      fontSize: 12,
                      fontWeight: 600,
                      border: "1px solid",
                      borderColor: activeColumnFilter === "all" ? "#101828" : "#e2e8f0",
                      background: activeColumnFilter === "all" ? "#101828" : "#f8fafc",
                      color: activeColumnFilter === "all" ? "#ffffff" : "#475569",
                      cursor: "pointer",
                      transition: "all 0.15s ease"
                    },
                    children: "All"
                  }), Array.from({
                    length: colCount
                  }, function (_, idx) {
                    var _active$style13;
                    var colBg = (_active$style13 = active.style) === null || _active$style13 === void 0 || (_active$style13 = _active$style13.columnBackgrounds) === null || _active$style13 === void 0 ? void 0 : _active$style13[idx];
                    var isSelectedTab = activeColumnFilter === idx;
                    return /*#__PURE__*/_jsxs("button", {
                      type: "button",
                      onClick: function onClick() {
                        setActiveColumnFilter(idx);
                        setCollapsedColumns(function (prev) {
                          return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, idx, false));
                        });
                      },
                      style: {
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 5,
                        padding: "4px 10px",
                        borderRadius: 999,
                        fontSize: 12,
                        fontWeight: 600,
                        border: "1px solid",
                        borderColor: isSelectedTab ? "#101828" : "#e2e8f0",
                        background: isSelectedTab ? "#101828" : "#f8fafc",
                        color: isSelectedTab ? "#ffffff" : "#475569",
                        cursor: "pointer",
                        transition: "all 0.15s ease"
                      },
                      children: [colBg && colBg !== "transparent" ? /*#__PURE__*/_jsx("span", {
                        style: {
                          width: 8,
                          height: 8,
                          borderRadius: "50%",
                          background: colBg,
                          border: "1px solid rgba(0,0,0,0.25)"
                        }
                      }) : /*#__PURE__*/_jsx("span", {
                        style: {
                          width: 6,
                          height: 6,
                          borderRadius: "50%",
                          background: isSelectedTab ? "#94a3b8" : "#cbd5e1"
                        }
                      }), "Col ", idx + 1]
                    }, idx);
                  })]
                }), function () {
                  var visibleIndices = activeColumnFilter === "all" ? Array.from({
                    length: colCount
                  }, function (_, idx) {
                    return idx;
                  }) : [activeColumnFilter].filter(function (idx) {
                    return idx < colCount;
                  });
                  return visibleIndices.map(function (idx) {
                    var _active$style14, _active$style15;
                    var isCollapsed = Boolean(collapsedColumns[idx]);
                    var colBg = (_active$style14 = active.style) === null || _active$style14 === void 0 || (_active$style14 = _active$style14.columnBackgrounds) === null || _active$style14 === void 0 ? void 0 : _active$style14[idx];
                    var isFiltered = activeColumnFilter === idx;
                    return /*#__PURE__*/_jsxs("div", {
                      style: {
                        border: "1.5px solid ".concat(isFiltered ? "#3b82f6" : "#e2e8f0"),
                        borderRadius: 10,
                        background: "#ffffff",
                        boxShadow: isFiltered ? "0 0 0 3px rgba(59, 130, 246, 0.1), 0 2px 4px rgba(0,0,0,0.05)" : "0 1px 3px rgba(0, 0, 0, 0.04)",
                        overflow: "hidden",
                        display: "flex",
                        flexDirection: "column",
                        transition: "all 0.15s ease",
                        marginBottom: 6
                      },
                      children: [/*#__PURE__*/_jsxs("div", {
                        style: {
                          background: isFiltered ? "#eff6ff" : "#f8fafc",
                          borderBottom: isCollapsed ? "none" : "1px solid ".concat(isFiltered ? "#bfdbfe" : "#e2e8f0"),
                          padding: "8px 12px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          gap: 8,
                          cursor: "pointer",
                          userSelect: "none"
                        },
                        onClick: function onClick() {
                          return setCollapsedColumns(function (prev) {
                            return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, idx, !prev[idx]));
                          });
                        },
                        title: "Click to collapse / expand column settings",
                        children: [/*#__PURE__*/_jsxs("div", {
                          style: {
                            display: "flex",
                            alignItems: "center",
                            gap: 8
                          },
                          children: [/*#__PURE__*/_jsx("span", {
                            style: {
                              width: 22,
                              height: 22,
                              borderRadius: 6,
                              background: isFiltered ? "#2563eb" : "#101828",
                              color: "#ffffff",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: 11,
                              fontWeight: 700
                            },
                            children: idx + 1
                          }), /*#__PURE__*/_jsxs("span", {
                            style: {
                              fontSize: 13,
                              fontWeight: 700,
                              color: isFiltered ? "#1e40af" : "#1e293b",
                              letterSpacing: "0.02em",
                              whiteSpace: "nowrap"
                            },
                            children: ["Column ", idx + 1]
                          }), colBg && colBg !== "transparent" && /*#__PURE__*/_jsx("span", {
                            title: "Background: ".concat(colBg),
                            style: {
                              width: 14,
                              height: 14,
                              borderRadius: "50%",
                              background: colBg,
                              border: "1px solid rgba(0,0,0,0.2)",
                              display: "inline-block",
                              flexShrink: 0
                            }
                          })]
                        }), /*#__PURE__*/_jsxs("div", {
                          style: {
                            display: "flex",
                            alignItems: "center",
                            gap: 5
                          },
                          onClick: function onClick(e) {
                            return e.stopPropagation();
                          },
                          children: [/*#__PURE__*/_jsx("button", {
                            type: "button",
                            onClick: function onClick() {
                              return typeof duplicateLayoutColumn === "function" && duplicateLayoutColumn(idx);
                            },
                            disabled: !canDuplicate,
                            style: {
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: 24,
                              height: 24,
                              background: canDuplicate ? "#101828" : "#e2e8f0",
                              color: canDuplicate ? "#ffffff" : "#94a3b8",
                              border: "none",
                              borderRadius: 5,
                              cursor: canDuplicate ? "pointer" : "not-allowed",
                              padding: 0
                            },
                            title: canDuplicate ? "Duplicate Column ".concat(idx + 1, " with design") : "Maximum ".concat(MAX_LAYOUT_COLUMNS, " columns allowed"),
                            children: /*#__PURE__*/_jsx(BuilderIcon, {
                              name: "duplicate",
                              size: 13
                            })
                          }), /*#__PURE__*/_jsx("button", {
                            type: "button",
                            onClick: function onClick() {
                              return removeLayoutColumn(idx);
                            },
                            disabled: !canRemove,
                            style: {
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: 24,
                              height: 24,
                              background: canRemove ? "#ef4444" : "#e2e8f0",
                              color: canRemove ? "#ffffff" : "#94a3b8",
                              border: "none",
                              borderRadius: 5,
                              cursor: canRemove ? "pointer" : "not-allowed",
                              padding: 0
                            },
                            title: canRemove ? "Delete Column ".concat(idx + 1) : "Minimum ".concat(MIN_LAYOUT_COLUMNS, " columns required"),
                            children: /*#__PURE__*/_jsx(BuilderIcon, {
                              name: "delete",
                              size: 13
                            })
                          })]
                        })]
                      }), !isCollapsed && /*#__PURE__*/_jsxs("div", {
                        style: {
                          padding: "12px",
                          display: "flex",
                          flexDirection: "column",
                          gap: 12
                        },
                        children: [/*#__PURE__*/_jsx(ColorPickerField, {
                          label: getColumnBackgroundLabel(idx, colCount),
                          value: ((_active$style15 = active.style) === null || _active$style15 === void 0 || (_active$style15 = _active$style15.columnBackgrounds) === null || _active$style15 === void 0 ? void 0 : _active$style15[idx]) || "transparent",
                          onChange: function onChange(val) {
                            return updateColumnBackground(idx, val, colCount);
                          }
                        }), /*#__PURE__*/_jsx(ColumnShellControls, {
                          widthValue: getColumnStyleValue(active.style, "columnWidths", idx),
                          heightValue: getColumnStyleValue(active.style, "columnHeights", idx),
                          paddingValue: getColumnStyleValue(active.style, "columnPaddings", idx),
                          onUpdateWidth: function onUpdateWidth(val) {
                            return updateColumnStyleValue(idx, "columnWidths", val, colCount);
                          },
                          onUpdateHeight: function onUpdateHeight(val) {
                            return updateColumnStyleValue(idx, "columnHeights", val, colCount);
                          },
                          onUpdatePadding: function onUpdatePadding(val) {
                            return updateColumnStyleValue(idx, "columnPaddings", val, colCount);
                          }
                        }), /*#__PURE__*/_jsx(ColumnBorderControls, {
                          styleValue: getColumnStyleValue(active.style, "columnBorderStyles", idx),
                          widthValue: getColumnStyleValue(active.style, "columnBorderWidths", idx),
                          colorValue: getColumnStyleValue(active.style, "columnBorderColors", idx),
                          radiusValue: getColumnStyleValue(active.style, "columnBorderRadii", idx),
                          onUpdateBorder: function onUpdateBorder(updates) {
                            return typeof updateColumnStyleValues === "function" ? updateColumnStyleValues(idx, updates, colCount) : updateColumnStyleValue(idx, "columnBorderStyles", updates.columnBorderStyles, colCount);
                          },
                          onUpdateStyle: function onUpdateStyle(val) {
                            return updateColumnStyleValue(idx, "columnBorderStyles", val, colCount);
                          },
                          onUpdateWidth: function onUpdateWidth(val) {
                            return updateColumnStyleValue(idx, "columnBorderWidths", val, colCount);
                          },
                          onUpdateColor: function onUpdateColor(val) {
                            return updateColumnStyleValue(idx, "columnBorderColors", val, colCount);
                          },
                          onUpdateRadius: function onUpdateRadius(val) {
                            return updateColumnStyleValue(idx, "columnBorderRadii", val, colCount);
                          }
                        }), /*#__PURE__*/_jsx(ColumnFlexControls, {
                          alignValue: getColumnStyleValue(active.style, "columnAlignItems", idx),
                          justifyValue: getColumnStyleValue(active.style, "columnJustifyContents", idx),
                          onUpdateAlign: function onUpdateAlign(val) {
                            return updateColumnStyleValue(idx, "columnAlignItems", val, colCount);
                          },
                          onUpdateJustify: function onUpdateJustify(val) {
                            return updateColumnStyleValue(idx, "columnJustifyContents", val, colCount);
                          }
                        })]
                      })]
                    }, idx);
                  });
                }()]
              });
            }(), /*#__PURE__*/_jsx(ColorPickerField, {
              label: "Text Color",
              value: (styleTarget === null || styleTarget === void 0 ? void 0 : styleTarget.color) || "",
              onChange: function onChange(val) {
                return css("color", val);
              }
            }), /*#__PURE__*/_jsx("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 12,
                paddingTop: 8,
                borderTop: "1px solid ".concat(UI.panelBorder)
              },
              children: /*#__PURE__*/_jsx(GapControls, {
                style: active.style || {},
                defaultGap: BLOCK_GAP_DEFAULTS[active.type] || 24,
                label: "Column Gap",
                sublabel: "Space between columns",
                onUpdate: function onUpdate(value) {
                  return css("gap", value);
                },
                onClear: function onClear() {
                  return css("gap", "0px");
                }
              })
            })]
          }), active.type === "quote" && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 8
              },
              children: [/*#__PURE__*/_jsx("label", {
                style: {
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#4b5563"
                },
                children: "Quote Text"
              }), /*#__PURE__*/_jsx("textarea", {
                rows: 3,
                value: ((_active$content20 = active.content) === null || _active$content20 === void 0 ? void 0 : _active$content20.text) || "",
                onChange: function onChange(e) {
                  return editContentField("text", e.target.value);
                },
                style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
                  fontFamily: "DM Sans, sans-serif",
                  fontWeight: 500,
                  fontSize: 14
                })
              })]
            }), /*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 8
              },
              children: [/*#__PURE__*/_jsx("label", {
                style: {
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#4b5563"
                },
                children: "Author Name"
              }), /*#__PURE__*/_jsx("input", {
                type: "text",
                value: ((_active$content21 = active.content) === null || _active$content21 === void 0 ? void 0 : _active$content21.author) || "",
                onChange: function onChange(e) {
                  return editContentField("author", e.target.value);
                },
                style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
                  fontFamily: "DM Sans, sans-serif",
                  fontWeight: 500,
                  fontSize: 14
                })
              })]
            }), /*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 8
              },
              children: [/*#__PURE__*/_jsx("label", {
                style: {
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#4b5563"
                },
                children: "Author Role"
              }), /*#__PURE__*/_jsx("input", {
                type: "text",
                value: ((_active$content22 = active.content) === null || _active$content22 === void 0 ? void 0 : _active$content22.role) || "",
                onChange: function onChange(e) {
                  return editContentField("role", e.target.value);
                },
                style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
                  fontFamily: "DM Sans, sans-serif",
                  fontWeight: 500,
                  fontSize: 14
                })
              })]
            })]
          }), active.type === "icon" && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(IconPickerField, {
              content: active.content,
              style: active.style,
              onSelectSvg: function onSelectSvg(iconName) {
                return editIconBlock === null || editIconBlock === void 0 ? void 0 : editIconBlock({
                  iconName: iconName,
                  symbol: ""
                });
              },
              onSelectEmoji: function onSelectEmoji(symbol) {
                return editIconBlock === null || editIconBlock === void 0 ? void 0 : editIconBlock({
                  iconName: "",
                  symbol: symbol
                });
              },
              onCustomSymbol: function onCustomSymbol(symbol) {
                return editIconBlock === null || editIconBlock === void 0 ? void 0 : editIconBlock({
                  iconName: "",
                  symbol: symbol
                });
              }
            }), /*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 8
              },
              children: [/*#__PURE__*/_jsx("label", {
                style: {
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#4b5563"
                },
                children: "Icon Size"
              }), /*#__PURE__*/_jsx("input", {
                type: "text",
                value: ((_active$content23 = active.content) === null || _active$content23 === void 0 ? void 0 : _active$content23.size) || "40px",
                onChange: function onChange(e) {
                  return editContentField("size", e.target.value);
                },
                placeholder: "40px",
                style: panelInputStyle
              })]
            })]
          }), active.type === "gallery" && /*#__PURE__*/_jsxs("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: 12
            },
            children: [/*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 8
              },
              children: [/*#__PURE__*/_jsx("label", {
                style: {
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#4b5563"
                },
                children: "Columns"
              }), /*#__PURE__*/_jsxs("select", {
                value: ((_active$content24 = active.content) === null || _active$content24 === void 0 ? void 0 : _active$content24.columns) || 3,
                onChange: function onChange(e) {
                  return editContentField("columns", parseInt(e.target.value, 10));
                },
                style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
                  fontFamily: "DM Sans, sans-serif",
                  fontWeight: 500,
                  fontSize: 14
                }),
                children: [/*#__PURE__*/_jsx("option", {
                  value: 2,
                  children: "2 Columns"
                }), /*#__PURE__*/_jsx("option", {
                  value: 3,
                  children: "3 Columns"
                }), /*#__PURE__*/_jsx("option", {
                  value: 4,
                  children: "4 Columns"
                })]
              })]
            }), (((_active$content25 = active.content) === null || _active$content25 === void 0 ? void 0 : _active$content25.images) || []).map(function (img, idx) {
              return /*#__PURE__*/_jsxs("div", {
                style: {
                  background: "#f9fafb",
                  border: "1px solid #e5e7eb",
                  borderRadius: 8,
                  padding: 10,
                  display: "flex",
                  flexDirection: "column",
                  gap: 8
                },
                children: [/*#__PURE__*/_jsxs("div", {
                  style: {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  },
                  children: [/*#__PURE__*/_jsxs("span", {
                    style: {
                      fontSize: 14,
                      fontWeight: 500,
                      color: "#6b7280"
                    },
                    children: ["Image ", idx + 1]
                  }), /*#__PURE__*/_jsx("button", {
                    onClick: function onClick() {
                      return removeGalleryImage(idx);
                    },
                    style: {
                      background: "#ef4444",
                      color: "#fff",
                      border: "none",
                      borderRadius: 4,
                      width: 28,
                      height: 28,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 10,
                      cursor: "pointer"
                    },
                    children: /*#__PURE__*/_jsx(BuilderIcon, {
                      name: "delete",
                      size: 16
                    })
                  })]
                }), /*#__PURE__*/_jsx(ImageUploadItem, {
                  value: img.src || "",
                  onUrlChange: function onUrlChange(url) {
                    return editGalleryImage(idx, "src", url);
                  },
                  onFileChange: function onFileChange(e) {
                    return handleGalleryImageUpload(idx, e);
                  },
                  uploading: imageUploading === "gallery-".concat(idx),
                  alt: img.alt || "",
                  onAltChange: function onAltChange(alt) {
                    return editGalleryImage(idx, "alt", alt);
                  },
                  altPlaceholder: "Gallery image alt text",
                  error: (imageUploadError === null || imageUploadError === void 0 ? void 0 : imageUploadError.key) === "gallery-".concat(idx) ? imageUploadError.message : null
                })]
              }, idx);
            }), /*#__PURE__*/_jsxs("button", {
              onClick: addGalleryImage,
              style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 8,
                background: '#101828',
                color: '#ffffff',
                border: "1px solid ".concat(UI.panelBorder),
                borderRadius: 8,
                padding: "8px 0",
                fontFamily: "DM Sans, sans-serif",
                fontWeight: 500,
                fontSize: 14,
                cursor: "pointer"
              },
              children: [/*#__PURE__*/_jsx(BuilderIcon, {
                name: "add",
                size: 20
              }), "Add Image"]
            })]
          }), active.type === "cta" && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 8
              },
              children: [/*#__PURE__*/_jsx("label", {
                style: {
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#4b5563"
                },
                children: "Headline"
              }), /*#__PURE__*/_jsx("input", {
                type: "text",
                value: ((_active$content26 = active.content) === null || _active$content26 === void 0 ? void 0 : _active$content26.title) || "",
                onChange: function onChange(e) {
                  return editContentField("title", e.target.value);
                },
                style: panelInputStyle
              })]
            }), /*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 8
              },
              children: [/*#__PURE__*/_jsx("label", {
                style: {
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#4b5563"
                },
                children: "Subtitle"
              }), /*#__PURE__*/_jsx("textarea", {
                rows: 2,
                value: ((_active$content27 = active.content) === null || _active$content27 === void 0 ? void 0 : _active$content27.subtitle) || "",
                onChange: function onChange(e) {
                  return editContentField("subtitle", e.target.value);
                },
                style: panelInputStyle
              })]
            }), /*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 8
              },
              children: [/*#__PURE__*/_jsx("label", {
                style: {
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#4b5563"
                },
                children: "Button Text"
              }), /*#__PURE__*/_jsx("input", {
                type: "text",
                value: ((_active$content28 = active.content) === null || _active$content28 === void 0 ? void 0 : _active$content28.buttonText) || "",
                onChange: function onChange(e) {
                  return editContentField("buttonText", e.target.value);
                },
                style: panelInputStyle
              })]
            }), /*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 8
              },
              children: [/*#__PURE__*/_jsx("label", {
                style: {
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#4b5563"
                },
                children: "Button URL"
              }), /*#__PURE__*/_jsx("input", {
                type: "text",
                value: ((_active$content29 = active.content) === null || _active$content29 === void 0 ? void 0 : _active$content29.buttonUrl) || "",
                onChange: function onChange(e) {
                  return editContentField("buttonUrl", e.target.value);
                },
                style: panelInputStyle
              })]
            })]
          }), active.type === "logos" && /*#__PURE__*/_jsxs("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: 12
            },
            children: [/*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 8
              },
              children: [/*#__PURE__*/_jsx("label", {
                style: {
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#4b5563"
                },
                children: "Section Title"
              }), /*#__PURE__*/_jsx("input", {
                type: "text",
                value: ((_active$content30 = active.content) === null || _active$content30 === void 0 ? void 0 : _active$content30.title) || "",
                onChange: function onChange(e) {
                  return editContentField("title", e.target.value);
                },
                style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
                  fontFamily: "DM Sans, sans-serif",
                  fontWeight: 500,
                  fontSize: 14
                })
              })]
            }), (((_active$content31 = active.content) === null || _active$content31 === void 0 ? void 0 : _active$content31.logos) || []).map(function (logo, idx) {
              return /*#__PURE__*/_jsxs("div", {
                style: {
                  background: "#f9fafb",
                  border: "1px solid #e5e7eb",
                  borderRadius: 8,
                  padding: 10,
                  display: "flex",
                  flexDirection: "column",
                  gap: 8
                },
                children: [/*#__PURE__*/_jsxs("div", {
                  style: {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  },
                  children: [/*#__PURE__*/_jsxs("span", {
                    style: {
                      fontSize: 13,
                      color: "#6b7280"
                    },
                    children: ["Logo ", idx + 1]
                  }), /*#__PURE__*/_jsx("button", {
                    onClick: function onClick() {
                      return removeLogo(idx);
                    },
                    style: {
                      background: "#ef4444",
                      color: "#fff",
                      border: "none",
                      borderRadius: 4,
                      width: 28,
                      height: 28,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 10,
                      cursor: "pointer"
                    },
                    children: /*#__PURE__*/_jsx(BuilderIcon, {
                      name: "delete",
                      size: 16
                    })
                  })]
                }), /*#__PURE__*/_jsx(ImageUploadItem, {
                  value: logo.src || "",
                  onUrlChange: function onUrlChange(url) {
                    return editLogo(idx, "src", url);
                  },
                  onFileChange: function onFileChange(e) {
                    return handleLogoImageUpload(idx, e);
                  },
                  uploading: imageUploading === "logo-".concat(idx),
                  alt: logo.alt || "",
                  onAltChange: function onAltChange(alt) {
                    return editLogo(idx, "alt", alt);
                  },
                  altPlaceholder: "Brand name / alt text",
                  error: (imageUploadError === null || imageUploadError === void 0 ? void 0 : imageUploadError.key) === "logo-".concat(idx) ? imageUploadError.message : null
                })]
              }, idx);
            }), /*#__PURE__*/_jsxs("button", {
              onClick: addLogo,
              style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 8,
                background: '#101828',
                color: '#ffffff',
                border: 'none',
                borderRadius: 6,
                padding: "10px 20px",
                fontFamily: "DM Sans, sans-serif",
                fontWeight: 500,
                fontSize: 14,
                cursor: "pointer"
              },
              children: [/*#__PURE__*/_jsx(BuilderIcon, {
                name: "add",
                size: 20
              }), "Add Logo"]
            })]
          }), active.type === "accordion" && /*#__PURE__*/_jsxs("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: 12
            },
            children: [(((_active$content32 = active.content) === null || _active$content32 === void 0 ? void 0 : _active$content32.items) || []).map(function (item, idx) {
              return /*#__PURE__*/_jsxs("div", {
                style: {
                  background: "#f9fafb",
                  border: "1px solid #e5e7eb",
                  borderRadius: 8,
                  padding: 10,
                  display: "flex",
                  flexDirection: "column",
                  gap: 8
                },
                children: [/*#__PURE__*/_jsxs("div", {
                  style: {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  },
                  children: [/*#__PURE__*/_jsxs("span", {
                    style: {
                      fontSize: 13,
                      fontWeight: 500,
                      color: "#6b7280"
                    },
                    children: ["Item ", idx + 1]
                  }), /*#__PURE__*/_jsx("button", {
                    onClick: function onClick() {
                      return removeAccordionItem(idx);
                    },
                    style: {
                      background: "#ef4444",
                      color: "#fff",
                      border: "none",
                      borderRadius: 4,
                      width: 28,
                      height: 28,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 10,
                      cursor: "pointer"
                    },
                    children: /*#__PURE__*/_jsx(BuilderIcon, {
                      name: "delete",
                      size: 16
                    })
                  })]
                }), /*#__PURE__*/_jsx("input", {
                  type: "text",
                  value: item.title || "",
                  onChange: function onChange(e) {
                    return editAccordionItem(idx, "title", e.target.value);
                  },
                  placeholder: "Question / Title",
                  style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
                    fontFamily: "DM Sans, sans-serif",
                    fontWeight: 500,
                    fontSize: 14
                  })
                }), /*#__PURE__*/_jsx("textarea", {
                  rows: 2,
                  value: item.body || "",
                  onChange: function onChange(e) {
                    return editAccordionItem(idx, "body", e.target.value);
                  },
                  placeholder: "Answer / Body",
                  style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
                    fontFamily: "DM Sans, sans-serif",
                    fontWeight: 500,
                    fontSize: 14
                  })
                })]
              }, idx);
            }), /*#__PURE__*/_jsxs("button", {
              onClick: addAccordionItem,
              style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 8,
                background: '#101828',
                color: '#ffffff',
                border: 'none',
                borderRadius: 6,
                padding: "10px 20px",
                fontFamily: "DM Sans, sans-serif",
                fontWeight: 500,
                fontSize: 14,
                cursor: "pointer"
              },
              children: [/*#__PURE__*/_jsx(BuilderIcon, {
                name: "add",
                size: 20
              }), "Add Accordion Item"]
            })]
          }), active.type === "pricing" && /*#__PURE__*/_jsxs("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: 14
            },
            children: [(((_active$content33 = active.content) === null || _active$content33 === void 0 ? void 0 : _active$content33.plans) || []).map(function (plan, pIdx) {
              var _active$content34;
              return /*#__PURE__*/_jsxs("div", {
                style: {
                  background: "#f9fafb",
                  border: "1px solid #e5e7eb",
                  borderRadius: 8,
                  padding: 10,
                  display: "flex",
                  flexDirection: "column",
                  gap: 8
                },
                children: [/*#__PURE__*/_jsxs("div", {
                  style: {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  },
                  children: [/*#__PURE__*/_jsxs("span", {
                    style: {
                      fontSize: 13,
                      fontWeight: 500,
                      color: "#6b7280"
                    },
                    children: ["Plan ", pIdx + 1]
                  }), ((_active$content34 = active.content) === null || _active$content34 === void 0 || (_active$content34 = _active$content34.plans) === null || _active$content34 === void 0 ? void 0 : _active$content34.length) > 1 && /*#__PURE__*/_jsx("button", {
                    onClick: function onClick() {
                      return removePricingPlan(pIdx);
                    },
                    style: {
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 28,
                      height: 28,
                      background: "#ef4444",
                      color: "#ffffff",
                      border: "none",
                      borderRadius: 4,
                      cursor: "pointer"
                    },
                    children: /*#__PURE__*/_jsx(BuilderIcon, {
                      name: "delete",
                      size: 16
                    })
                  })]
                }), /*#__PURE__*/_jsx("input", {
                  type: "text",
                  value: plan.name || "",
                  onChange: function onChange(e) {
                    return editPricingPlan(pIdx, "name", e.target.value);
                  },
                  placeholder: "Plan name",
                  style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
                    fontFamily: "DM Sans, sans-serif",
                    fontWeight: 500,
                    fontSize: 14
                  })
                }), /*#__PURE__*/_jsxs("div", {
                  style: {
                    display: "flex",
                    gap: 8
                  },
                  children: [/*#__PURE__*/_jsx("input", {
                    type: "text",
                    value: plan.price || "",
                    onChange: function onChange(e) {
                      return editPricingPlan(pIdx, "price", e.target.value);
                    },
                    placeholder: "Price",
                    style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
                      flex: 1,
                      fontFamily: "DM Sans, sans-serif",
                      fontWeight: 500,
                      fontSize: 14
                    })
                  }), /*#__PURE__*/_jsx("input", {
                    type: "text",
                    value: plan.period || "",
                    onChange: function onChange(e) {
                      return editPricingPlan(pIdx, "period", e.target.value);
                    },
                    placeholder: "/mo",
                    style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
                      width: 60,
                      fontFamily: "DM Sans, sans-serif",
                      fontWeight: 500,
                      fontSize: 14
                    })
                  })]
                }), /*#__PURE__*/_jsx("input", {
                  type: "text",
                  value: plan.buttonText || "",
                  onChange: function onChange(e) {
                    return editPricingPlan(pIdx, "buttonText", e.target.value);
                  },
                  placeholder: "Button text",
                  style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
                    fontFamily: "DM Sans, sans-serif",
                    fontWeight: 500,
                    fontSize: 14
                  })
                }), /*#__PURE__*/_jsxs("label", {
                  style: {
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    fontSize: 12,
                    color: "#4b5563",
                    marginTop: 4
                  },
                  children: [/*#__PURE__*/_jsx("input", {
                    type: "checkbox",
                    checked: !!plan.highlighted,
                    onChange: function onChange(e) {
                      return editPricingPlan(pIdx, "highlighted", e.target.checked);
                    }
                  }), "Highlight this plan"]
                }), (plan.features || []).map(function (feat, fIdx) {
                  return /*#__PURE__*/_jsxs("div", {
                    style: {
                      display: "flex",
                      gap: 6
                    },
                    children: [/*#__PURE__*/_jsx("input", {
                      type: "text",
                      value: feat,
                      onChange: function onChange(e) {
                        return editPricingFeature(pIdx, fIdx, e.target.value);
                      },
                      placeholder: "Feature ".concat(fIdx + 1),
                      style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
                        fontFamily: "DM Sans, sans-serif",
                        fontWeight: 500,
                        fontSize: 14,
                        flex: 1
                      })
                    }), /*#__PURE__*/_jsx("button", {
                      onClick: function onClick() {
                        return removePricingFeature(pIdx, fIdx);
                      },
                      style: {
                        background: "#ef4444",
                        color: "#ffffff",
                        border: "none",
                        borderRadius: 6,
                        padding: "0 10px",
                        cursor: "pointer",
                        fontSize: 12
                      },
                      children: /*#__PURE__*/_jsx(BuilderIcon, {
                        name: "delete",
                        size: 17
                      })
                    })]
                  }, fIdx);
                }), /*#__PURE__*/_jsxs("button", {
                  onClick: function onClick() {
                    return addPricingFeature(pIdx);
                  },
                  style: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 8,
                    background: '#003cb3',
                    color: '#ffffff',
                    border: 'none',
                    borderRadius: 6,
                    padding: "8px 20px",
                    fontFamily: "DM Sans, sans-serif",
                    fontWeight: 500,
                    fontSize: 14,
                    cursor: "pointer"
                  },
                  children: [/*#__PURE__*/_jsx(BuilderIcon, {
                    name: "add",
                    size: 20
                  }), "Add Feature"]
                })]
              }, pIdx);
            }), /*#__PURE__*/_jsxs("button", {
              onClick: addPricingPlan,
              style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 8,
                background: '#101828',
                color: '#ffffff',
                border: 'none',
                borderRadius: 6,
                padding: "10px 20px",
                fontFamily: "DM Sans, sans-serif",
                fontWeight: 500,
                fontSize: 14,
                cursor: "pointer",
                marginTop: 4
              },
              children: [/*#__PURE__*/_jsx(BuilderIcon, {
                name: "add",
                size: 20
              }), "Add Pricing Plan"]
            })]
          }), active.type === "testimonials" && /*#__PURE__*/_jsxs("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: 12
            },
            children: [(((_active$content35 = active.content) === null || _active$content35 === void 0 ? void 0 : _active$content35.items) || []).map(function (item, idx) {
              return /*#__PURE__*/_jsxs("div", {
                style: {
                  background: "#f9fafb",
                  border: "1px solid #e5e7eb",
                  borderRadius: 8,
                  padding: 10,
                  display: "flex",
                  flexDirection: "column",
                  gap: 8
                },
                children: [/*#__PURE__*/_jsxs("div", {
                  style: {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  },
                  children: [/*#__PURE__*/_jsxs("span", {
                    style: {
                      fontSize: 13,
                      fontWeight: 500,
                      color: "#6b7280"
                    },
                    children: ["Testimonial ", idx + 1]
                  }), /*#__PURE__*/_jsx("button", {
                    onClick: function onClick() {
                      return removeTestimonial(idx);
                    },
                    style: {
                      background: "#ef4444",
                      color: "#fff",
                      border: "none",
                      borderRadius: 4,
                      width: 28,
                      height: 28,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 10,
                      cursor: "pointer"
                    },
                    children: /*#__PURE__*/_jsx(BuilderIcon, {
                      name: "delete",
                      size: 16
                    })
                  })]
                }), /*#__PURE__*/_jsx("textarea", {
                  rows: 2,
                  value: item.quote || "",
                  onChange: function onChange(e) {
                    return editTestimonial(idx, "quote", e.target.value);
                  },
                  placeholder: "Quote",
                  style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
                    fontFamily: "DM Sans, sans-serif",
                    fontWeight: 500,
                    fontSize: 14
                  })
                }), /*#__PURE__*/_jsx("input", {
                  type: "text",
                  value: item.name || "",
                  onChange: function onChange(e) {
                    return editTestimonial(idx, "name", e.target.value);
                  },
                  placeholder: "Client name",
                  style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
                    fontFamily: "DM Sans, sans-serif",
                    fontWeight: 500,
                    fontSize: 14
                  })
                }), /*#__PURE__*/_jsx("input", {
                  type: "text",
                  value: item.role || "",
                  onChange: function onChange(e) {
                    return editTestimonial(idx, "role", e.target.value);
                  },
                  placeholder: "Role / Company",
                  style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
                    fontFamily: "DM Sans, sans-serif",
                    fontWeight: 500,
                    fontSize: 14
                  })
                })]
              }, idx);
            }), /*#__PURE__*/_jsxs("button", {
              onClick: addTestimonial,
              style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 8,
                background: '#101828',
                color: '#ffffff',
                border: 'none',
                borderRadius: 6,
                padding: "10px 20px",
                fontFamily: "DM Sans, sans-serif",
                fontWeight: 500,
                fontSize: 14,
                cursor: "pointer"
              },
              children: [/*#__PURE__*/_jsx(BuilderIcon, {
                name: "add",
                size: 20
              }), "Add Testimonial"]
            })]
          }), active.type === "cover" && /*#__PURE__*/_jsxs("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: 12
            },
            children: [/*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 8
              },
              children: [/*#__PURE__*/_jsx("label", {
                style: {
                  fontSize: 13,
                  fontWeight: 500,
                  color: "#4b5563"
                },
                children: "Title"
              }), /*#__PURE__*/_jsx("input", {
                type: "text",
                value: ((_active$content36 = active.content) === null || _active$content36 === void 0 ? void 0 : _active$content36.title) || "",
                onChange: function onChange(e) {
                  return editContentField("title", e.target.value);
                },
                style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
                  fontFamily: "DM Sans, sans-serif",
                  fontWeight: 500,
                  fontSize: 14
                })
              })]
            }), /*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 8
              },
              children: [/*#__PURE__*/_jsx("label", {
                style: {
                  fontSize: 13,
                  fontWeight: 500,
                  color: "#4b5563"
                },
                children: "Subtitle"
              }), /*#__PURE__*/_jsx("input", {
                type: "text",
                value: ((_active$content37 = active.content) === null || _active$content37 === void 0 ? void 0 : _active$content37.subtitle) || "",
                onChange: function onChange(e) {
                  return editContentField("subtitle", e.target.value);
                },
                style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
                  fontFamily: "DM Sans, sans-serif",
                  fontWeight: 500,
                  fontSize: 14
                })
              })]
            }), /*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 8
              },
              children: [/*#__PURE__*/_jsx("label", {
                style: {
                  fontSize: 13,
                  fontWeight: 500,
                  color: "#4b5563"
                },
                children: "Description / Intro"
              }), /*#__PURE__*/_jsx("textarea", {
                rows: 4,
                value: ((_active$content38 = active.content) === null || _active$content38 === void 0 ? void 0 : _active$content38.description) || "",
                onChange: function onChange(e) {
                  return editContentField("description", e.target.value);
                },
                style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
                  resize: "vertical",
                  fontFamily: "DM Sans, sans-serif",
                  fontWeight: 500,
                  fontSize: 14
                })
              })]
            }), /*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 8
              },
              children: [/*#__PURE__*/_jsx("label", {
                style: {
                  fontSize: 13,
                  fontWeight: 500,
                  color: "#4b5563"
                },
                children: "Prepared By"
              }), /*#__PURE__*/_jsx("input", {
                type: "text",
                value: ((_active$content39 = active.content) === null || _active$content39 === void 0 ? void 0 : _active$content39.author) || "",
                onChange: function onChange(e) {
                  return editContentField("author", e.target.value);
                },
                style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
                  fontFamily: "DM Sans, sans-serif",
                  fontWeight: 500,
                  fontSize: 14
                })
              })]
            }), /*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 8
              },
              children: [/*#__PURE__*/_jsx("label", {
                style: {
                  fontSize: 13,
                  fontWeight: 500,
                  color: "#4b5563"
                },
                children: "Date"
              }), /*#__PURE__*/_jsx("input", {
                type: "text",
                value: ((_active$content40 = active.content) === null || _active$content40 === void 0 ? void 0 : _active$content40.date) || "",
                onChange: function onChange(e) {
                  return editContentField("date", e.target.value);
                },
                style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
                  fontFamily: "DM Sans, sans-serif",
                  fontWeight: 500,
                  fontSize: 14
                })
              })]
            })]
          }), active.type === "signature" && /*#__PURE__*/_jsx("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: 14
            },
            children: [{
              prefix: "client",
              title: "Client Side",
              nameLabel: "Representative Name",
              namePlaceholder: "Client Name",
              titlePlaceholder: "Client Representative",
              datePlaceholder: "June 24, 2026",
              signedLabel: "Client has signed",
              signaturePlaceholder: "Type Client's Name"
            }, {
              prefix: "provider",
              title: "Provider Side",
              nameLabel: "Representative Name",
              namePlaceholder: "Provider Name",
              titlePlaceholder: "Director, WillowSpace",
              datePlaceholder: "June 24, 2026",
              signedLabel: "Provider has signed",
              signaturePlaceholder: "Type Provider's Name"
            }].map(function (section) {
              var _active$content41, _active$content42, _active$content43, _active$content44, _active$content45;
              return /*#__PURE__*/_jsxs("div", {
                style: {
                  background: "#f9fafb",
                  border: "1px solid #e5e7eb",
                  borderRadius: 8,
                  padding: 12,
                  display: "flex",
                  flexDirection: "column",
                  gap: 8
                },
                children: [/*#__PURE__*/_jsx("span", {
                  style: {
                    fontSize: 11,
                    color: "#818cf8",
                    fontWeight: 600,
                    textTransform: "uppercase"
                  },
                  children: section.title
                }), /*#__PURE__*/_jsxs("div", {
                  style: {
                    display: "flex",
                    flexDirection: "column",
                    gap: 4
                  },
                  children: [/*#__PURE__*/_jsx("label", {
                    style: {
                      fontSize: 11,
                      color: "#6b7280"
                    },
                    children: section.nameLabel
                  }), /*#__PURE__*/_jsx("input", {
                    type: "text",
                    value: ((_active$content41 = active.content) === null || _active$content41 === void 0 ? void 0 : _active$content41["".concat(section.prefix, "Name")]) || "",
                    onChange: function onChange(e) {
                      return editContentField("".concat(section.prefix, "Name"), e.target.value);
                    },
                    placeholder: section.namePlaceholder,
                    style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
                      fontFamily: "DM Sans, sans-serif",
                      fontWeight: 500,
                      fontSize: 14
                    })
                  })]
                }), /*#__PURE__*/_jsxs("div", {
                  style: {
                    display: "flex",
                    flexDirection: "column",
                    gap: 4
                  },
                  children: [/*#__PURE__*/_jsx("label", {
                    style: {
                      fontSize: 11,
                      color: "#6b7280"
                    },
                    children: "Title / Role"
                  }), /*#__PURE__*/_jsx("input", {
                    type: "text",
                    value: ((_active$content42 = active.content) === null || _active$content42 === void 0 ? void 0 : _active$content42["".concat(section.prefix, "Title")]) || "",
                    onChange: function onChange(e) {
                      return editContentField("".concat(section.prefix, "Title"), e.target.value);
                    },
                    placeholder: section.titlePlaceholder,
                    style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
                      fontFamily: "DM Sans, sans-serif",
                      fontWeight: 500,
                      fontSize: 14
                    })
                  })]
                }), /*#__PURE__*/_jsxs("div", {
                  style: {
                    display: "flex",
                    flexDirection: "column",
                    gap: 4
                  },
                  children: [/*#__PURE__*/_jsx("label", {
                    style: {
                      fontSize: 11,
                      color: "#6b7280"
                    },
                    children: "Date"
                  }), /*#__PURE__*/_jsx("input", {
                    type: "text",
                    value: ((_active$content43 = active.content) === null || _active$content43 === void 0 ? void 0 : _active$content43["".concat(section.prefix, "Date")]) || "",
                    onChange: function onChange(e) {
                      return editContentField("".concat(section.prefix, "Date"), e.target.value);
                    },
                    placeholder: section.datePlaceholder,
                    style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
                      fontFamily: "DM Sans, sans-serif",
                      fontWeight: 500,
                      fontSize: 14
                    })
                  })]
                }), /*#__PURE__*/_jsxs("div", {
                  style: {
                    display: "flex",
                    flexDirection: "column",
                    gap: 4
                  },
                  children: [/*#__PURE__*/_jsx("label", {
                    style: {
                      fontSize: 11,
                      color: "#6b7280"
                    },
                    children: "Signature Text"
                  }), /*#__PURE__*/_jsx("input", {
                    type: "text",
                    value: ((_active$content44 = active.content) === null || _active$content44 === void 0 ? void 0 : _active$content44["".concat(section.prefix, "Signature")]) || "",
                    onChange: function onChange(e) {
                      return editContentField("".concat(section.prefix, "Signature"), e.target.value);
                    },
                    placeholder: "Type name as it should appear signed",
                    style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
                      fontFamily: "DM Sans, sans-serif",
                      fontWeight: 500,
                      fontSize: 14
                    })
                  }), /*#__PURE__*/_jsx("span", {
                    style: {
                      fontSize: 12,
                      fontWeight: 400,
                      color: "#64748b",
                      lineHeight: 1.4
                    },
                    children: "This text shows in script font above the line. It is separate from Representative Name."
                  })]
                }), /*#__PURE__*/_jsxs("label", {
                  style: {
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    fontSize: 13,
                    fontWeight: 500,
                    color: "#4b5563",
                    marginTop: 4
                  },
                  children: [/*#__PURE__*/_jsx("input", {
                    type: "checkbox",
                    checked: !!((_active$content45 = active.content) !== null && _active$content45 !== void 0 && _active$content45["".concat(section.prefix, "Signed")]),
                    onChange: function onChange(e) {
                      editContentField("".concat(section.prefix, "Signed"), e.target.checked);
                    }
                  }), section.signedLabel]
                })]
              }, section.prefix);
            })
          }), active.type === "timeline" && /*#__PURE__*/_jsxs("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: 14
            },
            children: [/*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 6
              },
              children: [/*#__PURE__*/_jsx("label", {
                style: {
                  fontSize: 13,
                  fontWeight: 600,
                  color: "#4b5563"
                },
                children: "Style / Layout"
              }), /*#__PURE__*/_jsxs("select", {
                value: ((_active$content46 = active.content) === null || _active$content46 === void 0 ? void 0 : _active$content46.timelineStyle) || "numbered-circle",
                onChange: function onChange(e) {
                  return editContentField("timelineStyle", e.target.value);
                },
                style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
                  fontFamily: "DM Sans, sans-serif",
                  fontWeight: 500,
                  fontSize: 14
                }),
                children: [/*#__PURE__*/_jsx("option", {
                  value: "numbered-circle",
                  children: "Numbered Circles (1, 2, 3...)"
                }), /*#__PURE__*/_jsx("option", {
                  value: "numbered-step",
                  children: "Numbered Steps (01, 02...)"
                }), /*#__PURE__*/_jsx("option", {
                  value: "classic-dot",
                  children: "Classic Dot"
                })]
              })]
            }), /*#__PURE__*/_jsx(ColorPickerField, {
              label: "Accent & Line Color",
              value: ((_active$content47 = active.content) === null || _active$content47 === void 0 ? void 0 : _active$content47.accentColor) || "#c8a896",
              onChange: function onChange(v) {
                return editContentField("accentColor", v);
              }
            }), /*#__PURE__*/_jsx("div", {
              style: {
                display: "flex",
                gap: 8,
                alignItems: "center",
                marginTop: -4
              },
              children: [{
                color: "#c8a896",
                title: "Terracotta / Warm Rose"
              }, {
                color: "#b87a68",
                title: "Earth Clay"
              }, {
                color: "#101828",
                title: "Charcoal Slate"
              }, {
                color: "#4f46e5",
                title: "Indigo"
              }, {
                color: "#059669",
                title: "Emerald"
              }].map(function (preset) {
                var _active$content48;
                return /*#__PURE__*/_jsx("button", {
                  type: "button",
                  title: preset.title,
                  onClick: function onClick() {
                    return editContentField("accentColor", preset.color);
                  },
                  style: {
                    width: 24,
                    height: 24,
                    borderRadius: "50%",
                    background: preset.color,
                    border: (((_active$content48 = active.content) === null || _active$content48 === void 0 ? void 0 : _active$content48.accentColor) || "#c8a896") === preset.color ? "2px solid #111827" : "1px solid #d1d5db",
                    cursor: "pointer",
                    padding: 0,
                    outline: "none"
                  }
                }, preset.color);
              })
            }), /*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 8
              },
              children: [/*#__PURE__*/_jsxs("div", {
                style: {
                  display: "flex",
                  alignItems: "center",
                  gap: 8
                },
                children: [/*#__PURE__*/_jsx("input", {
                  type: "checkbox",
                  id: "timeline-show-number-toggle",
                  checked: ((_active$content49 = active.content) === null || _active$content49 === void 0 ? void 0 : _active$content49.showNumber) !== false,
                  onChange: function onChange(e) {
                    return editContentField("showNumber", e.target.checked);
                  },
                  style: {
                    width: 16,
                    height: 16,
                    cursor: "pointer"
                  }
                }), /*#__PURE__*/_jsx("label", {
                  htmlFor: "timeline-show-number-toggle",
                  style: {
                    fontSize: 13,
                    fontWeight: 500,
                    color: "#4b5563",
                    cursor: "pointer"
                  },
                  children: "Show Step Numbers (01, 02...)"
                })]
              }), /*#__PURE__*/_jsxs("div", {
                style: {
                  display: "flex",
                  alignItems: "center",
                  gap: 8
                },
                children: [/*#__PURE__*/_jsx("input", {
                  type: "checkbox",
                  id: "timeline-show-date-toggle",
                  checked: ((_active$content50 = active.content) === null || _active$content50 === void 0 ? void 0 : _active$content50.showDate) !== undefined ? !!active.content.showDate : ((_active$content51 = active.content) === null || _active$content51 === void 0 ? void 0 : _active$content51.timelineStyle) === "classic-dot",
                  onChange: function onChange(e) {
                    return editContentField("showDate", e.target.checked);
                  },
                  style: {
                    width: 16,
                    height: 16,
                    cursor: "pointer"
                  }
                }), /*#__PURE__*/_jsx("label", {
                  htmlFor: "timeline-show-date-toggle",
                  style: {
                    fontSize: 13,
                    fontWeight: 500,
                    color: "#4b5563",
                    cursor: "pointer"
                  },
                  children: "Show Dates / Phases"
                })]
              })]
            }), /*#__PURE__*/_jsxs("div", {
              style: {
                borderTop: "1px solid #e5e7eb",
                paddingTop: 10,
                display: "flex",
                flexDirection: "column",
                gap: 10
              },
              children: [/*#__PURE__*/_jsx("span", {
                style: {
                  fontSize: 13,
                  fontWeight: 600,
                  color: "#374151"
                },
                children: "Steps / Milestones"
              }), (((_active$content52 = active.content) === null || _active$content52 === void 0 ? void 0 : _active$content52.items) || []).map(function (item, idx) {
                var _active$content54, _active$content57, _active$content58;
                return /*#__PURE__*/_jsxs("div", {
                  style: {
                    background: "#f9fafb",
                    border: "1px solid #e5e7eb",
                    borderRadius: 8,
                    padding: 10,
                    display: "flex",
                    flexDirection: "column",
                    gap: 8
                  },
                  children: [/*#__PURE__*/_jsxs("div", {
                    style: {
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center"
                    },
                    children: [/*#__PURE__*/_jsxs("span", {
                      style: {
                        fontSize: 13,
                        fontWeight: 600,
                        color: "#6b7280"
                      },
                      children: ["Step ", idx + 1]
                    }), /*#__PURE__*/_jsxs("div", {
                      style: {
                        display: "flex",
                        gap: 6,
                        alignItems: "center"
                      },
                      children: [/*#__PURE__*/_jsx("button", {
                        type: "button",
                        title: "Duplicate / Copy Step",
                        onClick: function onClick() {
                          if (typeof duplicateTimelineItem === "function") {
                            duplicateTimelineItem(idx);
                          } else {
                            var _active$content53;
                            var items = _toConsumableArray(((_active$content53 = active.content) === null || _active$content53 === void 0 ? void 0 : _active$content53.items) || []);
                            if (items[idx]) {
                              var cloned = JSON.parse(JSON.stringify(items[idx]));
                              if (cloned.number && !isNaN(parseInt(cloned.number, 10))) {
                                var nextNum = parseInt(cloned.number, 10) + 1;
                                cloned.number = cloned.number.startsWith("0") ? String(nextNum).padStart(cloned.number.length, "0") : String(nextNum);
                              }
                              items.splice(idx + 1, 0, cloned);
                              editContentField("items", items);
                            }
                          }
                        },
                        style: {
                          background: "#f3f4f6",
                          color: "#374151",
                          border: "1px solid #d1d5db",
                          borderRadius: 4,
                          width: 28,
                          height: 28,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer"
                        },
                        children: /*#__PURE__*/_jsx(BuilderIcon, {
                          name: "duplicate",
                          size: 15
                        })
                      }), /*#__PURE__*/_jsx("button", {
                        type: "button",
                        title: "Delete Step",
                        onClick: function onClick() {
                          return removeTimelineItem(idx);
                        },
                        style: {
                          background: "#ef4444",
                          color: "#fff",
                          border: "none",
                          borderRadius: 4,
                          width: 28,
                          height: 28,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: 10,
                          cursor: "pointer"
                        },
                        children: /*#__PURE__*/_jsx(BuilderIcon, {
                          name: "delete",
                          size: 16
                        })
                      })]
                    })]
                  }), /*#__PURE__*/_jsxs("div", {
                    style: {
                      display: "flex",
                      gap: 8,
                      alignItems: "center"
                    },
                    children: [((_active$content54 = active.content) === null || _active$content54 === void 0 ? void 0 : _active$content54.showNumber) !== false && function (_active$content55, _active$content56) {
                      var defaultStepNum = ((_active$content55 = active.content) === null || _active$content55 === void 0 ? void 0 : _active$content55.timelineStyle) === "numbered-step" ? String(idx + 1).padStart(2, "0") : String(idx + 1);
                      var isCleared = item.number === "";
                      var displayNum = isCleared ? "" : item.number !== undefined ? item.number : defaultStepNum;
                      return /*#__PURE__*/_jsxs("div", {
                        style: {
                          position: "relative",
                          display: "inline-flex",
                          alignItems: "center"
                        },
                        children: [/*#__PURE__*/_jsx("input", {
                          type: "text",
                          value: displayNum,
                          onChange: function onChange(e) {
                            return editTimelineItem(idx, "number", e.target.value);
                          },
                          placeholder: "No #",
                          title: "Step Number (clear or click \u2715 to remove)",
                          style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
                            width: "68px",
                            flexShrink: 0,
                            textAlign: "center",
                            fontFamily: "DM Sans, sans-serif",
                            fontWeight: 600,
                            fontSize: 14,
                            color: isCleared ? "#9ca3af" : ((_active$content56 = active.content) === null || _active$content56 === void 0 ? void 0 : _active$content56.accentColor) || "#c8a896",
                            paddingRight: "22px"
                          })
                        }), !isCleared ? /*#__PURE__*/_jsx("button", {
                          type: "button",
                          title: "Remove Number",
                          onClick: function onClick() {
                            return editTimelineItem(idx, "number", "");
                          },
                          style: {
                            position: "absolute",
                            right: 5,
                            background: "none",
                            border: "none",
                            color: "#9ca3af",
                            fontSize: 12,
                            cursor: "pointer",
                            padding: 2,
                            lineHeight: 1
                          },
                          children: "\u2715"
                        }) : /*#__PURE__*/_jsx("button", {
                          type: "button",
                          title: "Restore Number",
                          onClick: function onClick() {
                            return editTimelineItem(idx, "number", defaultStepNum);
                          },
                          style: {
                            position: "absolute",
                            right: 5,
                            background: "none",
                            border: "none",
                            color: "#3b82f6",
                            fontSize: 12,
                            cursor: "pointer",
                            padding: 2,
                            lineHeight: 1,
                            fontWeight: "bold"
                          },
                          children: "+"
                        })]
                      });
                    }(), /*#__PURE__*/_jsx("input", {
                      type: "text",
                      value: item.title || "",
                      onChange: function onChange(e) {
                        return editTimelineItem(idx, "title", e.target.value);
                      },
                      placeholder: "Step Title",
                      style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
                        flex: 1,
                        minWidth: 0,
                        fontFamily: "DM Sans, sans-serif",
                        fontWeight: 500,
                        fontSize: 14
                      })
                    })]
                  }), (((_active$content57 = active.content) === null || _active$content57 === void 0 ? void 0 : _active$content57.showDate) !== undefined ? !!active.content.showDate : ((_active$content58 = active.content) === null || _active$content58 === void 0 ? void 0 : _active$content58.timelineStyle) === "classic-dot") && /*#__PURE__*/_jsx("input", {
                    type: "text",
                    value: item.date || "",
                    onChange: function onChange(e) {
                      return editTimelineItem(idx, "date", e.target.value);
                    },
                    placeholder: "Date or Phase (optional)",
                    style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
                      fontFamily: "DM Sans, sans-serif",
                      fontWeight: 500,
                      fontSize: 14
                    })
                  }), /*#__PURE__*/_jsx("textarea", {
                    rows: 2,
                    value: item.description || "",
                    onChange: function onChange(e) {
                      return editTimelineItem(idx, "description", e.target.value);
                    },
                    placeholder: "Step description",
                    style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
                      resize: "vertical",
                      fontFamily: "DM Sans, sans-serif",
                      fontWeight: 500,
                      fontSize: 14
                    })
                  })]
                }, idx);
              }), /*#__PURE__*/_jsxs("button", {
                onClick: addTimelineItem,
                style: {
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 8,
                  background: '#101828',
                  color: '#ffffff',
                  border: 'none',
                  borderRadius: 6,
                  padding: "10px 20px",
                  fontFamily: "DM Sans, sans-serif",
                  fontWeight: 500,
                  fontSize: 14,
                  cursor: "pointer"
                },
                children: [/*#__PURE__*/_jsx(BuilderIcon, {
                  name: "add",
                  size: 20
                }), "Add Step / Milestone"]
              })]
            })]
          }), active.type === "text-banner" && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 8
              },
              children: [/*#__PURE__*/_jsx("label", {
                style: {
                  fontSize: 13,
                  fontWeight: 500,
                  color: "#4b5563"
                },
                children: "Title"
              }), /*#__PURE__*/_jsx("input", {
                type: "text",
                value: ((_active$content59 = active.content) === null || _active$content59 === void 0 ? void 0 : _active$content59.title) || "",
                onChange: function onChange(e) {
                  return editContentField("title", e.target.value);
                },
                style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
                  fontFamily: "DM Sans, sans-serif",
                  fontWeight: 500,
                  fontSize: 14
                })
              })]
            }), /*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 8
              },
              children: [/*#__PURE__*/_jsx("label", {
                style: {
                  fontSize: 13,
                  fontWeight: 500,
                  color: "#4b5563"
                },
                children: "Message"
              }), /*#__PURE__*/_jsx("input", {
                type: "text",
                value: ((_active$content60 = active.content) === null || _active$content60 === void 0 ? void 0 : _active$content60.text) || "",
                onChange: function onChange(e) {
                  return editContentField("text", e.target.value);
                },
                style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
                  fontFamily: "DM Sans, sans-serif",
                  fontWeight: 500,
                  fontSize: 14
                })
              })]
            }), /*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 8
              },
              children: [/*#__PURE__*/_jsx("label", {
                style: {
                  fontSize: 13,
                  fontWeight: 500,
                  color: "#4b5563"
                },
                children: "Link Text (optional)"
              }), /*#__PURE__*/_jsx("input", {
                type: "text",
                value: ((_active$content61 = active.content) === null || _active$content61 === void 0 ? void 0 : _active$content61.linkText) || "",
                onChange: function onChange(e) {
                  return editContentField("linkText", e.target.value);
                },
                style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
                  fontFamily: "DM Sans, sans-serif",
                  fontWeight: 500,
                  fontSize: 14
                })
              })]
            }), /*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 8
              },
              children: [/*#__PURE__*/_jsx("label", {
                style: {
                  fontSize: 13,
                  fontWeight: 500,
                  color: "#4b5563"
                },
                children: "Link URL"
              }), /*#__PURE__*/_jsx("input", {
                type: "text",
                value: ((_active$content62 = active.content) === null || _active$content62 === void 0 ? void 0 : _active$content62.link) || "",
                onChange: function onChange(e) {
                  return editContentField("link", e.target.value);
                },
                style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
                  fontFamily: "DM Sans, sans-serif",
                  fontWeight: 500,
                  fontSize: 14
                })
              })]
            })]
          }), active.type === "table" && /*#__PURE__*/_jsxs("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: 12
            },
            children: [/*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
              },
              children: [/*#__PURE__*/_jsx("label", {
                style: {
                  fontSize: 13,
                  fontWeight: 700,
                  color: "#101828",
                  textTransform: "uppercase",
                  letterSpacing: "0.04em"
                },
                children: "Table Grid Settings"
              }), /*#__PURE__*/_jsxs("span", {
                style: {
                  fontSize: 11,
                  color: "#64748b",
                  fontWeight: 500
                },
                children: [(((_active$content63 = active.content) === null || _active$content63 === void 0 ? void 0 : _active$content63.rows) || []).length, " ", (((_active$content64 = active.content) === null || _active$content64 === void 0 ? void 0 : _active$content64.rows) || []).length === 1 ? "Row" : "Rows", " \u2022 ", (((_active$content65 = active.content) === null || _active$content65 === void 0 ? void 0 : _active$content65.headers) || []).length, " Cols"]
              })]
            }), /*#__PURE__*/_jsx("div", {
              style: {
                overflowX: "auto",
                background: "#f8fafc",
                borderRadius: 8,
                padding: 10,
                border: "1px solid #e2e8f0"
              },
              children: /*#__PURE__*/_jsxs("table", {
                style: {
                  width: "100%",
                  borderCollapse: "separate",
                  borderSpacing: "6px"
                },
                children: [/*#__PURE__*/_jsx("thead", {
                  children: /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("th", {
                      style: {
                        width: 24,
                        fontSize: 11,
                        color: "#94a3b8",
                        fontWeight: 600,
                        textAlign: "center",
                        padding: 0
                      },
                      children: "#"
                    }), (active.content.headers || []).map(function (th, cI) {
                      return /*#__PURE__*/_jsx("th", {
                        style: {
                          verticalAlign: "bottom",
                          padding: 0
                        },
                        children: /*#__PURE__*/_jsxs("div", {
                          style: {
                            display: "flex",
                            flexDirection: "column",
                            gap: 4,
                            minWidth: 90
                          },
                          children: [/*#__PURE__*/_jsxs("div", {
                            style: {
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              padding: "0 2px"
                            },
                            children: [/*#__PURE__*/_jsxs("span", {
                              style: {
                                fontSize: 10,
                                fontWeight: 700,
                                color: "#64748b",
                                textTransform: "uppercase"
                              },
                              children: ["Col ", cI + 1]
                            }), (active.content.headers || []).length > 1 && /*#__PURE__*/_jsx("button", {
                              type: "button",
                              onClick: function onClick() {
                                return removeTableColumn(cI);
                              },
                              style: {
                                background: "#fee2e2",
                                color: "#ef4444",
                                border: "1px solid #fca5a5",
                                width: 20,
                                height: 20,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                                borderRadius: 4,
                                padding: 0,
                                transition: "all 0.15s ease"
                              },
                              title: "Delete Column ".concat(cI + 1),
                              children: /*#__PURE__*/_jsx(BuilderIcon, {
                                name: "delete",
                                size: 12
                              })
                            })]
                          }), /*#__PURE__*/_jsx("input", {
                            type: "text",
                            value: th,
                            onChange: function onChange(e) {
                              return editTableHeader(cI, e.target.value);
                            },
                            placeholder: "Header ".concat(cI + 1),
                            style: {
                              width: "100%",
                              boxSizing: "border-box",
                              background: "#ffffff",
                              border: "1px solid #cbd5e1",
                              borderRadius: 6,
                              color: "#0f172a",
                              fontSize: 12,
                              fontFamily: "DM Sans, sans-serif",
                              fontWeight: 600,
                              padding: "6px 8px",
                              outline: "none"
                            }
                          })]
                        })
                      }, cI);
                    }), /*#__PURE__*/_jsx("th", {
                      style: {
                        width: 56,
                        fontSize: 11,
                        color: "#94a3b8",
                        fontWeight: 600,
                        textAlign: "center",
                        padding: 0
                      },
                      children: "Actions"
                    })]
                  })
                }), /*#__PURE__*/_jsx("tbody", {
                  children: (active.content.rows || []).map(function (row, rI) {
                    return /*#__PURE__*/_jsxs("tr", {
                      children: [/*#__PURE__*/_jsx("td", {
                        style: {
                          width: 24,
                          fontSize: 11,
                          color: "#94a3b8",
                          fontWeight: 600,
                          textAlign: "center",
                          padding: 0
                        },
                        children: rI + 1
                      }), (row || []).map(function (td, cI) {
                        return /*#__PURE__*/_jsx("td", {
                          style: {
                            padding: 0
                          },
                          children: /*#__PURE__*/_jsx("input", {
                            type: "text",
                            value: td,
                            onChange: function onChange(e) {
                              return editTableCell(rI, cI, e.target.value);
                            },
                            placeholder: "Cell value",
                            style: {
                              width: "100%",
                              minWidth: 90,
                              boxSizing: "border-box",
                              background: "#ffffff",
                              border: "1px solid #e2e8f0",
                              borderRadius: 6,
                              color: "#334155",
                              fontSize: 12,
                              fontFamily: "DM Sans, sans-serif",
                              fontWeight: 500,
                              padding: "6px 8px",
                              outline: "none"
                            }
                          })
                        }, cI);
                      }), /*#__PURE__*/_jsx("td", {
                        style: {
                          width: 56,
                          padding: 0,
                          textAlign: "center"
                        },
                        children: /*#__PURE__*/_jsxs("div", {
                          style: {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 4
                          },
                          children: [/*#__PURE__*/_jsx("button", {
                            type: "button",
                            onClick: function onClick() {
                              return duplicateTableRow(rI);
                            },
                            style: {
                              background: "#f1f5f9",
                              color: "#334155",
                              border: "1px solid #cbd5e1",
                              width: 26,
                              height: 26,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: "pointer",
                              borderRadius: 4,
                              padding: 0,
                              transition: "all 0.15s ease"
                            },
                            title: "Duplicate Row (with design & content)",
                            children: /*#__PURE__*/_jsx(BuilderIcon, {
                              name: "duplicate",
                              size: 13
                            })
                          }), /*#__PURE__*/_jsx("button", {
                            type: "button",
                            onClick: function onClick() {
                              return removeTableRow(rI);
                            },
                            style: {
                              background: "#fee2e2",
                              color: "#ef4444",
                              border: "1px solid #fca5a5",
                              width: 26,
                              height: 26,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: "pointer",
                              borderRadius: 4,
                              padding: 0,
                              transition: "all 0.15s ease"
                            },
                            title: "Delete Row",
                            children: /*#__PURE__*/_jsx(BuilderIcon, {
                              name: "delete",
                              size: 13
                            })
                          })]
                        })
                      })]
                    }, rI);
                  })
                })]
              })
            }), /*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                justifyContent: "flex-end",
                gap: 8
              },
              children: [/*#__PURE__*/_jsxs("button", {
                type: "button",
                onClick: addTableColumn,
                style: {
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 6,
                  background: "#ffffff",
                  color: "#374151",
                  border: "1px solid #d1d5db",
                  borderRadius: 6,
                  padding: "6px 12px",
                  fontFamily: "DM Sans, sans-serif",
                  fontWeight: 600,
                  fontSize: 12,
                  cursor: "pointer",
                  boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                  transition: "all 0.15s ease"
                },
                children: [/*#__PURE__*/_jsx(BuilderIcon, {
                  name: "add",
                  size: 14
                }), "Add Column"]
              }), /*#__PURE__*/_jsxs("button", {
                type: "button",
                onClick: addTableRow,
                style: {
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 6,
                  background: "#101828",
                  color: "#ffffff",
                  border: "1px solid #101828",
                  borderRadius: 6,
                  padding: "6px 12px",
                  fontFamily: "DM Sans, sans-serif",
                  fontWeight: 600,
                  fontSize: 12,
                  cursor: "pointer",
                  boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                  transition: "all 0.15s ease"
                },
                children: [/*#__PURE__*/_jsx(BuilderIcon, {
                  name: "add",
                  size: 14
                }), "Add Row"]
              })]
            }), /*#__PURE__*/_jsxs("div", {
              style: {
                border: "1px solid #e2e8f0",
                borderRadius: 10,
                background: "#ffffff",
                padding: 12,
                display: "flex",
                flexDirection: "column",
                gap: 12,
                boxShadow: "0 1px 3px rgba(0,0,0,0.04)"
              },
              children: [/*#__PURE__*/_jsxs("div", {
                style: {
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between"
                },
                children: [/*#__PURE__*/_jsx("span", {
                  style: {
                    fontSize: 13,
                    fontWeight: 700,
                    color: "#101828",
                    textTransform: "uppercase",
                    letterSpacing: "0.04em"
                  },
                  children: "Table Borders & Grid"
                }), (((_active$style16 = active.style) === null || _active$style16 === void 0 ? void 0 : _active$style16.tableBorderStyle) && ((_active$style17 = active.style) === null || _active$style17 === void 0 ? void 0 : _active$style17.tableBorderStyle) !== "solid" || ((_active$style18 = active.style) === null || _active$style18 === void 0 ? void 0 : _active$style18.tableBorderWidth) && ((_active$style19 = active.style) === null || _active$style19 === void 0 ? void 0 : _active$style19.tableBorderWidth) !== "1px" || ((_active$style20 = active.style) === null || _active$style20 === void 0 ? void 0 : _active$style20.tableBorderColor) && ((_active$style21 = active.style) === null || _active$style21 === void 0 ? void 0 : _active$style21.tableBorderColor) !== "#e2e8f0") && /*#__PURE__*/_jsx("button", {
                  type: "button",
                  onClick: function onClick() {
                    applyStylePatch(function (newStyle) {
                      newStyle.tableBorderStyle = "solid";
                      newStyle.tableBorderWidth = "1px";
                      newStyle.tableBorderColor = "#e2e8f0";
                      return newStyle;
                    }, {
                      blockOnly: true
                    });
                  },
                  style: {
                    background: "none",
                    border: "none",
                    color: "#ef4444",
                    fontSize: 11,
                    cursor: "pointer",
                    fontWeight: 600,
                    padding: 0
                  },
                  children: "Reset"
                })]
              }), /*#__PURE__*/_jsx(TableBorderControls, {
                styleValue: ((_active$style22 = active.style) === null || _active$style22 === void 0 ? void 0 : _active$style22.tableBorderStyle) || "solid",
                widthValue: ((_active$style23 = active.style) === null || _active$style23 === void 0 ? void 0 : _active$style23.tableBorderWidth) !== undefined ? active.style.tableBorderWidth : "1px",
                colorValue: ((_active$style24 = active.style) === null || _active$style24 === void 0 ? void 0 : _active$style24.tableBorderColor) || "#e2e8f0",
                onChangeStyle: function onChangeStyle(val) {
                  return css("tableBorderStyle", val, {
                    blockOnly: true
                  });
                },
                onChangeWidth: function onChangeWidth(val) {
                  return css("tableBorderWidth", val, {
                    blockOnly: true
                  });
                },
                onReset: function onReset() {
                  applyStylePatch(function (newStyle) {
                    newStyle.tableBorderStyle = "solid";
                    newStyle.tableBorderWidth = "1px";
                    newStyle.tableBorderColor = "#e2e8f0";
                    return newStyle;
                  }, {
                    blockOnly: true
                  });
                }
              }), /*#__PURE__*/_jsx(ColorPickerField, {
                label: "Grid Border Color",
                value: ((_active$style25 = active.style) === null || _active$style25 === void 0 ? void 0 : _active$style25.tableBorderColor) || "#e2e8f0",
                onChange: function onChange(val) {
                  return css("tableBorderColor", val, {
                    blockOnly: true
                  });
                }
              }), /*#__PURE__*/_jsx(TableCellPaddingControls, {
                paddingValue: ((_active$style26 = active.style) === null || _active$style26 === void 0 ? void 0 : _active$style26.cellPadding) || "10px",
                onChangePadding: function onChangePadding(val) {
                  return css("cellPadding", val, {
                    blockOnly: true
                  });
                }
              })]
            }), /*#__PURE__*/_jsxs("div", {
              style: {
                border: "1px solid #e2e8f0",
                borderRadius: 10,
                background: "#ffffff",
                padding: 12,
                display: "flex",
                flexDirection: "column",
                gap: 12,
                boxShadow: "0 1px 3px rgba(0,0,0,0.04)"
              },
              children: [/*#__PURE__*/_jsx("span", {
                style: {
                  fontSize: 13,
                  fontWeight: 700,
                  color: "#101828",
                  textTransform: "uppercase",
                  letterSpacing: "0.04em"
                },
                children: "Row & Cell Colors"
              }), /*#__PURE__*/_jsx(ColorPickerField, {
                label: "Header Row Background",
                value: ((_active$style27 = active.style) === null || _active$style27 === void 0 ? void 0 : _active$style27.headerBackground) || "#f8fafc",
                onChange: function onChange(val) {
                  return css("headerBackground", val, {
                    blockOnly: true
                  });
                }
              }), /*#__PURE__*/_jsx(ColorPickerField, {
                label: "Header Text Color",
                value: ((_active$style28 = active.style) === null || _active$style28 === void 0 ? void 0 : _active$style28.headerColor) || ((_active$style29 = active.style) === null || _active$style29 === void 0 ? void 0 : _active$style29.color) || "#101828",
                onChange: function onChange(val) {
                  return css("headerColor", val, {
                    blockOnly: true
                  });
                }
              }), /*#__PURE__*/_jsx(ColorPickerField, {
                label: "Row / Cell Background",
                value: ((_active$style30 = active.style) === null || _active$style30 === void 0 ? void 0 : _active$style30.rowBackground) || "transparent",
                onChange: function onChange(val) {
                  return css("rowBackground", val, {
                    blockOnly: true
                  });
                }
              }), /*#__PURE__*/_jsxs("div", {
                style: {
                  display: "flex",
                  flexDirection: "column",
                  gap: 8,
                  paddingTop: 6,
                  borderTop: "1px dashed #e2e8f0"
                },
                children: [/*#__PURE__*/_jsxs("label", {
                  style: {
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    cursor: "pointer",
                    fontSize: 13,
                    fontWeight: 500,
                    color: "#334155"
                  },
                  children: [/*#__PURE__*/_jsx("input", {
                    type: "checkbox",
                    checked: Boolean((_active$style31 = active.style) === null || _active$style31 === void 0 ? void 0 : _active$style31.stripedRows),
                    onChange: function onChange(e) {
                      return css("stripedRows", e.target.checked, {
                        blockOnly: true
                      });
                    },
                    style: {
                      cursor: "pointer",
                      width: 16,
                      height: 16,
                      accentColor: "#101828"
                    }
                  }), "Alternating Row Color (Zebra)"]
                }), Boolean((_active$style32 = active.style) === null || _active$style32 === void 0 ? void 0 : _active$style32.stripedRows) && /*#__PURE__*/_jsx(ColorPickerField, {
                  label: "Alternate Row Background",
                  value: ((_active$style33 = active.style) === null || _active$style33 === void 0 ? void 0 : _active$style33.stripedRowBackground) || "#f8fafc",
                  onChange: function onChange(val) {
                    return css("stripedRowBackground", val, {
                      blockOnly: true
                    });
                  }
                })]
              })]
            })]
          })]
        }), activeRightTab === "style" && /*#__PURE__*/_jsxs("div", {
          style: {
            display: "flex",
            flexDirection: "column"
          },
          children: [/*#__PURE__*/_jsxs("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: 20,
              padding: 20
            },
            children: [/*#__PURE__*/_jsx("span", {
              style: {
                fontSize: 16,
                fontWeight: 500,
                textTransform: "uppercase",
                color: "#101828"
              },
              children: "Typography"
            }), active.type !== "divider" && active.type !== "image" && active.type !== "html" && active.type !== "spacer" && /*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 8
              },
              children: [/*#__PURE__*/_jsx("span", {
                style: {
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#4b5563"
                },
                children: "Text Alignment"
              }), /*#__PURE__*/_jsx("div", {
                style: {
                  display: "flex",
                  gap: 10
                },
                children: ["left", "center", "right"].map(function (align) {
                  return /*#__PURE__*/_jsx("button", {
                    onClick: function onClick() {
                      return css("textAlign", align);
                    },
                    style: {
                      flex: "0 0 auto",
                      border: "none",
                      alignItems: "center",
                      justifyContent: "center",
                      display: "flex",
                      background: (styleTarget === null || styleTarget === void 0 ? void 0 : styleTarget.textAlign) === align ? '#101828' : "#F2F4F7",
                      color: (styleTarget === null || styleTarget === void 0 ? void 0 : styleTarget.textAlign) === align ? '#ffffff' : '#101828',
                      borderRadius: 40,
                      cursor: "pointer",
                      width: 40,
                      height: 40,
                      fontSize: 12,
                      textTransform: "capitalize",
                      transition: "all 0.15s"
                    },
                    children: /*#__PURE__*/_jsx(BuilderIcon, {
                      name: align,
                      size: 20
                    })
                  }, align);
                })
              })]
            }), active.type !== "divider" && active.type !== "image" && active.type !== "html" && active.type !== "spacer" && active.type !== "social" && /*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 8
              },
              children: [/*#__PURE__*/_jsx("span", {
                style: {
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#4b5563"
                },
                children: "Font Family"
              }), /*#__PURE__*/_jsx(SearchableFontSelect, {
                value: (styleTarget === null || styleTarget === void 0 ? void 0 : styleTarget.fontFamily) || "",
                onChange: function onChange(fontFamily) {
                  return css("fontFamily", fontFamily);
                },
                includeDefault: true
              })]
            }), active.type !== "divider" && active.type !== "image" && active.type !== "html" && active.type !== "spacer" && active.type !== "social" && /*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 8
              },
              children: [/*#__PURE__*/_jsx("span", {
                style: {
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#4b5563"
                },
                children: "Font Weight"
              }), /*#__PURE__*/_jsx("div", {
                style: {
                  display: "flex",
                  background: UI.tabTrack,
                  borderRadius: 6,
                  padding: 2
                },
                children: [{
                  l: "Light",
                  v: "300"
                }, {
                  l: "Regular",
                  v: "400"
                }, {
                  l: "Medium",
                  v: "500"
                }, {
                  l: "Semibold",
                  v: "600"
                }, {
                  l: "Bold",
                  v: "700"
                }].map(function (w) {
                  return /*#__PURE__*/_jsx("button", {
                    onClick: function onClick() {
                      return css("fontWeight", w.v);
                    },
                    style: {
                      flex: 1,
                      border: "none",
                      background: (styleTarget === null || styleTarget === void 0 ? void 0 : styleTarget.fontWeight) === w.v ? UI.tabActive : "transparent",
                      color: (styleTarget === null || styleTarget === void 0 ? void 0 : styleTarget.fontWeight) === w.v ? UI.tabActiveText : UI.tabInactiveText,
                      boxShadow: (styleTarget === null || styleTarget === void 0 ? void 0 : styleTarget.fontWeight) === w.v ? UI.shadow : "none",
                      padding: "6px 0",
                      borderRadius: 4,
                      cursor: "pointer",
                      fontSize: 10,
                      transition: "all 0.15s"
                    },
                    children: w.l
                  }, w.v);
                })
              })]
            }), active.type !== "divider" && active.type !== "image" && active.type !== "html" && active.type !== "spacer" && active.type !== "social" && /*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 8
              },
              children: [/*#__PURE__*/_jsx("span", {
                style: {
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#4b5563"
                },
                children: "Text Transform"
              }), /*#__PURE__*/_jsx("div", {
                style: {
                  display: "flex",
                  background: UI.tabTrack,
                  borderRadius: 6,
                  padding: 2,
                  flexWrap: "wrap"
                },
                children: [{
                  l: "None",
                  v: "none"
                }, {
                  l: "Capitalize",
                  v: "capitalize"
                }, {
                  l: "Uppercase",
                  v: "uppercase"
                }, {
                  l: "Lowercase",
                  v: "lowercase"
                }].map(function (opt) {
                  var current = (styleTarget === null || styleTarget === void 0 ? void 0 : styleTarget.textTransform) || "none";
                  var isActive = current === opt.v;
                  return /*#__PURE__*/_jsx("button", {
                    type: "button",
                    onClick: function onClick() {
                      return css("textTransform", opt.v === "none" ? "" : opt.v);
                    },
                    style: {
                      flex: 1,
                      minWidth: 0,
                      border: "none",
                      background: isActive ? UI.tabActive : "transparent",
                      color: isActive ? UI.tabActiveText : UI.tabInactiveText,
                      boxShadow: isActive ? UI.shadow : "none",
                      padding: "6px 4px",
                      borderRadius: 4,
                      cursor: "pointer",
                      fontSize: 10,
                      transition: "all 0.15s"
                    },
                    children: opt.l
                  }, opt.v);
                })
              })]
            }), active.type !== "divider" && active.type !== "image" && active.type !== "html" && active.type !== "spacer" && active.type !== "social" && /*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 8
              },
              children: [/*#__PURE__*/_jsxs("div", {
                style: {
                  display: "flex",
                  justifyContent: "space-between",
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#4b5563"
                },
                children: [/*#__PURE__*/_jsx("span", {
                  style: {
                    color: "#4b5563"
                  },
                  children: "Font Size"
                }), /*#__PURE__*/_jsx("span", {
                  style: {
                    color: "#64748b"
                  },
                  children: (styleTarget === null || styleTarget === void 0 ? void 0 : styleTarget.fontSize) || "16px"
                })]
              }), /*#__PURE__*/_jsx("input", {
                type: "range",
                min: "10",
                max: "100",
                value: parseInt(styleTarget === null || styleTarget === void 0 ? void 0 : styleTarget.fontSize) || 16,
                onChange: function onChange(e) {
                  return css("fontSize", e.target.value + "px");
                },
                style: {
                  width: "100%",
                  cursor: "pointer",
                  accentColor: "#101828"
                }
              })]
            }), active.type !== "divider" && active.type !== "image" && active.type !== "html" && active.type !== "spacer" && /*#__PURE__*/_jsx(ColorPickerField, {
              label: "Text Color",
              value: (styleTarget === null || styleTarget === void 0 ? void 0 : styleTarget.color) || "",
              onChange: function onChange(val) {
                return css("color", val);
              }
            })]
          }), active.type !== "divider" && active.type !== "image" && /*#__PURE__*/_jsxs("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: 20,
              borderTop: "1px solid ".concat(UI.panelBorder),
              padding: 20
            },
            children: [/*#__PURE__*/_jsx("span", {
              style: {
                fontSize: 16,
                fontWeight: 500,
                textTransform: "uppercase",
                color: "#101828"
              },
              children: isElementStyleMode ? selectedElement === "buttonText" || selectedElement !== null && selectedElement !== void 0 && selectedElement.endsWith("_buttonText") ? "Button Background" : "Background" : "Background"
            }), active.type !== "divider" && /*#__PURE__*/_jsx(ColorPickerField, {
              label: "Background Color",
              value: isElementStyleMode ? elementOnlyStyle.background && elementOnlyStyle.background !== "transparent" ? elementOnlyStyle.background : "transparent" : styleTarget !== null && styleTarget !== void 0 && styleTarget.background && styleTarget.background !== "transparent" ? styleTarget.background : "transparent",
              onChange: function onChange(val) {
                return css("background", val);
              }
            }), !isElementStyleMode && active.type !== "divider" && /*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 10
              },
              children: [/*#__PURE__*/_jsxs("div", {
                style: {
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center"
                },
                children: [/*#__PURE__*/_jsx("label", {
                  style: {
                    fontSize: 14,
                    fontWeight: 500,
                    color: "#4b5563"
                  },
                  children: "Gradient Builder"
                }), /*#__PURE__*/_jsx("button", {
                  type: "button",
                  onClick: function onClick() {
                    var _active$style34;
                    return css("background", buildGradient(getGradientValues((_active$style34 = active.style) === null || _active$style34 === void 0 ? void 0 : _active$style34.background)));
                  },
                  style: {
                    background: "#101828",
                    border: "none",
                    borderRadius: 6,
                    color: "#ffffff",
                    padding: "6px 10px",
                    fontSize: 11,
                    fontWeight: 600,
                    cursor: "pointer"
                  },
                  children: "Apply Gradient"
                })]
              }), /*#__PURE__*/_jsxs("div", {
                style: {
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: 8
                },
                children: [/*#__PURE__*/_jsx(ColorPickerField, {
                  label: "Start",
                  value: getGradientValues((_active$style35 = active.style) === null || _active$style35 === void 0 ? void 0 : _active$style35.background).start,
                  onChange: function onChange(start) {
                    var _active$style36;
                    var current = getGradientValues((_active$style36 = active.style) === null || _active$style36 === void 0 ? void 0 : _active$style36.background);
                    css("background", buildGradient(_objectSpread(_objectSpread({}, current), {}, {
                      start: start
                    })));
                  }
                }), /*#__PURE__*/_jsx(ColorPickerField, {
                  label: "End",
                  value: getGradientValues((_active$style37 = active.style) === null || _active$style37 === void 0 ? void 0 : _active$style37.background).end,
                  onChange: function onChange(end) {
                    var _active$style38;
                    var current = getGradientValues((_active$style38 = active.style) === null || _active$style38 === void 0 ? void 0 : _active$style38.background);
                    css("background", buildGradient(_objectSpread(_objectSpread({}, current), {}, {
                      end: end
                    })));
                  }
                })]
              }), /*#__PURE__*/_jsxs("div", {
                style: {
                  display: "flex",
                  flexDirection: "column",
                  gap: 4
                },
                children: [/*#__PURE__*/_jsxs("div", {
                  style: {
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: 12,
                    color: "#64748b"
                  },
                  children: [/*#__PURE__*/_jsx("span", {
                    children: "Angle"
                  }), /*#__PURE__*/_jsxs("span", {
                    children: [getGradientValues((_active$style39 = active.style) === null || _active$style39 === void 0 ? void 0 : _active$style39.background).angle, "\xB0"]
                  })]
                }), /*#__PURE__*/_jsx("input", {
                  type: "range",
                  min: "0",
                  max: "360",
                  value: getGradientValues((_active$style40 = active.style) === null || _active$style40 === void 0 ? void 0 : _active$style40.background).angle,
                  onChange: function onChange(e) {
                    var _active$style41;
                    var current = getGradientValues((_active$style41 = active.style) === null || _active$style41 === void 0 ? void 0 : _active$style41.background);
                    css("background", buildGradient(_objectSpread(_objectSpread({}, current), {}, {
                      angle: Number(e.target.value)
                    })));
                  },
                  style: {
                    width: "100%",
                    cursor: "pointer",
                    accentColor: "#101828"
                  }
                })]
              })]
            }), !isElementStyleMode && /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx(ImageUploadField, {
                label: "Background Image",
                value: getBackgroundImageUrl(active.style),
                onUrlChange: setBackgroundImageUrl,
                onFileChange: handleBackgroundImageUpload,
                uploading: imageUploading === "background-image",
                onRemove: function onRemove() {
                  return setBackgroundImageUrl("");
                },
                error: (imageUploadError === null || imageUploadError === void 0 ? void 0 : imageUploadError.key) === "background-image" ? imageUploadError.message : null
              }), getBackgroundImageUrl(active.style) && /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsxs("div", {
                  style: {
                    display: "flex",
                    flexDirection: "column",
                    gap: 8
                  },
                  children: [/*#__PURE__*/_jsx("label", {
                    style: {
                      fontSize: 14,
                      fontWeight: 500,
                      color: "#4b5563"
                    },
                    children: "Background Size"
                  }), /*#__PURE__*/_jsxs("select", {
                    value: ((_active$style42 = active.style) === null || _active$style42 === void 0 ? void 0 : _active$style42.backgroundSize) || "cover",
                    onChange: function onChange(e) {
                      return css("backgroundSize", e.target.value);
                    },
                    style: _objectSpread(_objectSpread({}, panelFieldStyle), {}, {
                      fontFamily: "DM Sans, sans-serif",
                      fontSize: 14,
                      fontWeight: 500,
                      color: "#4b5563",
                      padding: "6px 10px",
                      cursor: "pointer"
                    }),
                    children: [/*#__PURE__*/_jsx("option", {
                      value: "cover",
                      children: "Cover"
                    }), /*#__PURE__*/_jsx("option", {
                      value: "contain",
                      children: "Contain"
                    }), /*#__PURE__*/_jsx("option", {
                      value: "auto",
                      children: "Auto"
                    }), /*#__PURE__*/_jsx("option", {
                      value: "100% 100%",
                      children: "Stretch (100%)"
                    })]
                  })]
                }), /*#__PURE__*/_jsxs("div", {
                  style: {
                    display: "flex",
                    flexDirection: "column",
                    gap: 8
                  },
                  children: [/*#__PURE__*/_jsx("label", {
                    style: {
                      fontSize: 14,
                      fontWeight: 500,
                      color: "#4b5563"
                    },
                    children: "Background Position"
                  }), /*#__PURE__*/_jsxs("select", {
                    value: ((_active$style43 = active.style) === null || _active$style43 === void 0 ? void 0 : _active$style43.backgroundPosition) || "center",
                    onChange: function onChange(e) {
                      return css("backgroundPosition", e.target.value);
                    },
                    style: _objectSpread(_objectSpread({}, panelFieldStyle), {}, {
                      fontFamily: "DM Sans, sans-serif",
                      fontSize: 14,
                      fontWeight: 500,
                      color: "#4b5563",
                      padding: "6px 10px",
                      cursor: "pointer"
                    }),
                    children: [/*#__PURE__*/_jsx("option", {
                      value: "center",
                      children: "Center"
                    }), /*#__PURE__*/_jsx("option", {
                      value: "top",
                      children: "Top"
                    }), /*#__PURE__*/_jsx("option", {
                      value: "bottom",
                      children: "Bottom"
                    }), /*#__PURE__*/_jsx("option", {
                      value: "left",
                      children: "Left"
                    }), /*#__PURE__*/_jsx("option", {
                      value: "right",
                      children: "Right"
                    }), /*#__PURE__*/_jsx("option", {
                      value: "top left",
                      children: "Top Left"
                    }), /*#__PURE__*/_jsx("option", {
                      value: "top right",
                      children: "Top Right"
                    }), /*#__PURE__*/_jsx("option", {
                      value: "bottom left",
                      children: "Bottom Left"
                    }), /*#__PURE__*/_jsx("option", {
                      value: "bottom right",
                      children: "Bottom Right"
                    })]
                  })]
                }), /*#__PURE__*/_jsxs("div", {
                  style: {
                    display: "flex",
                    flexDirection: "column",
                    gap: 8
                  },
                  children: [/*#__PURE__*/_jsx("label", {
                    style: {
                      fontSize: 14,
                      fontWeight: 500,
                      color: "#4b5563"
                    },
                    children: "Background Repeat"
                  }), /*#__PURE__*/_jsxs("select", {
                    value: ((_active$style44 = active.style) === null || _active$style44 === void 0 ? void 0 : _active$style44.backgroundRepeat) || "no-repeat",
                    onChange: function onChange(e) {
                      return css("backgroundRepeat", e.target.value);
                    },
                    style: _objectSpread(_objectSpread({}, panelFieldStyle), {}, {
                      fontFamily: "DM Sans, sans-serif",
                      fontSize: 14,
                      fontWeight: 500,
                      color: "#4b5563",
                      padding: "6px 10px",
                      cursor: "pointer"
                    }),
                    children: [/*#__PURE__*/_jsx("option", {
                      value: "no-repeat",
                      children: "No Repeat"
                    }), /*#__PURE__*/_jsx("option", {
                      value: "repeat",
                      children: "Repeat"
                    }), /*#__PURE__*/_jsx("option", {
                      value: "repeat-x",
                      children: "Repeat X"
                    }), /*#__PURE__*/_jsx("option", {
                      value: "repeat-y",
                      children: "Repeat Y"
                    })]
                  })]
                }), /*#__PURE__*/_jsxs("div", {
                  style: {
                    display: "flex",
                    flexDirection: "column",
                    gap: 10
                  },
                  children: [/*#__PURE__*/_jsxs("div", {
                    style: {
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center"
                    },
                    children: [/*#__PURE__*/_jsx("label", {
                      style: {
                        fontSize: 14,
                        fontWeight: 500,
                        color: "#4b5563"
                      },
                      children: "Image Overlay"
                    }), /*#__PURE__*/_jsxs("span", {
                      style: {
                        fontSize: 12,
                        fontWeight: 500,
                        color: "#64748b"
                      },
                      children: [getBackgroundOverlayOpacity(active.style), "%"]
                    })]
                  }), /*#__PURE__*/_jsx("p", {
                    style: {
                      margin: 0,
                      fontSize: 12,
                      color: "#64748b",
                      lineHeight: 1.4
                    },
                    children: "Dark tint over the image so white text stays readable (PandaDoc-style)."
                  }), /*#__PURE__*/_jsx("input", {
                    type: "range",
                    min: "0",
                    max: "80",
                    value: getBackgroundOverlayOpacity(active.style),
                    onChange: function onChange(e) {
                      return css("backgroundOverlayOpacity", Number(e.target.value));
                    },
                    style: {
                      width: "100%",
                      cursor: "pointer",
                      accentColor: "#101828"
                    }
                  }), /*#__PURE__*/_jsx(ColorPickerField, {
                    label: "Overlay Color",
                    value: getBackgroundOverlayColor(active.style),
                    onChange: function onChange(val) {
                      return css("backgroundOverlayColor", val || "#000000");
                    }
                  })]
                })]
              })]
            })]
          }), /*#__PURE__*/_jsxs("div", {
            style: {
              borderTop: "1px solid ".concat(UI.panelBorder),
              display: "flex",
              flexDirection: "column",
              gap: 20,
              padding: 20
            },
            children: [/*#__PURE__*/_jsx("span", {
              style: {
                fontSize: 16,
                fontWeight: 500,
                textTransform: "uppercase",
                color: "#101828"
              },
              children: "Spacing & Layout"
            }), isColumnLayoutType(active.type) ? /*#__PURE__*/_jsx("p", {
              style: {
                margin: 0,
                fontSize: 13,
                color: "#64748b",
                lineHeight: 1.45
              },
              children: "Column width, height, padding, and flex are on the Content tab. Background, border, and padding on this tab apply to the whole section."
            }) : null, /*#__PURE__*/_jsx(LayoutControls, {
              style: active.style || {},
              onUpdateSize: updateSize,
              onUpdateOffset: updateOffset,
              onUpdatePosition: updatePosition,
              onUpdateZIndex: updateZIndex,
              showMaxWidth: (active === null || active === void 0 ? void 0 : active.type) === "heading" || (active === null || active === void 0 ? void 0 : active.type) === "text"
            }), /*#__PURE__*/_jsx(SpacingControls, {
              label: "Padding",
              property: "padding",
              style: active.style || {},
              onUpdateSide: function onUpdateSide(side, value, unit) {
                return updateSpacing("padding", side, value, unit);
              },
              onUpdateAll: function onUpdateAll(value, unit) {
                return updateSpacingAll("padding", value, unit);
              },
              onUnlink: function onUnlink() {
                return toggleSpacingMode("padding");
              },
              onClear: function onClear() {
                return updateSpacingAll("padding", 0, "px");
              }
            }), /*#__PURE__*/_jsx(SpacingControls, {
              label: "Margin",
              property: "margin",
              allowNegative: true,
              style: active.style || {},
              onUpdateSide: function onUpdateSide(side, value, unit) {
                return updateSpacing("margin", side, value, unit);
              },
              onUpdateAll: function onUpdateAll(value, unit) {
                return updateSpacingAll("margin", value, unit);
              },
              onUnlink: function onUnlink() {
                return toggleSpacingMode("margin");
              },
              onClear: function onClear() {
                return updateSpacingAll("margin", 0, "px");
              }
            }), !isElementStyleMode && active.type !== "group" && /*#__PURE__*/_jsx(GapControls, {
              style: active.style || {},
              defaultGap: BLOCK_GAP_DEFAULTS[active.type] || 0,
              label: isColumnLayoutType(active.type) ? "Column Gap" : "Gap",
              sublabel: isColumnLayoutType(active.type) ? "Space between columns" : "Space between items",
              onUpdate: function onUpdate(value) {
                return css("gap", value);
              },
              onClear: function onClear() {
                return css("gap", "0px");
              }
            }), !isElementStyleMode && active.type !== "divider" && /*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 8
              },
              children: [/*#__PURE__*/_jsx("label", {
                style: {
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#4b5563"
                },
                children: "Shape / Diagonal Clip"
              }), /*#__PURE__*/_jsx("select", {
                value: ((_active$style45 = active.style) === null || _active$style45 === void 0 ? void 0 : _active$style45.clipPath) || "",
                onChange: function onChange(e) {
                  return css("clipPath", e.target.value || undefined);
                },
                style: {
                  width: "100%",
                  background: "#ffffff",
                  border: "1px solid #d1d5db",
                  borderRadius: 6,
                  fontFamily: "DM Sans, sans-serif",
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#4b5563",
                  cursor: "pointer",
                  padding: "6px 10px",
                  outline: "none"
                },
                children: CLIP_PATH_PRESETS.map(function (preset) {
                  return /*#__PURE__*/_jsx("option", {
                    value: preset.value,
                    children: preset.label
                  }, preset.label);
                })
              })]
            }), !isElementStyleMode && active.type !== "divider" && /*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 10
              },
              children: [/*#__PURE__*/_jsxs("div", {
                style: {
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center"
                },
                children: [/*#__PURE__*/_jsx("label", {
                  style: {
                    fontSize: 14,
                    fontWeight: 500,
                    color: "#4b5563"
                  },
                  children: "Transform"
                }), /*#__PURE__*/_jsx("button", {
                  type: "button",
                  onClick: function onClick() {
                    return css("transform", "none");
                  },
                  style: {
                    background: "#f2f4f7",
                    border: "1px solid #d1d5db",
                    borderRadius: 6,
                    color: "#101828",
                    padding: "4px 8px",
                    fontSize: 11,
                    cursor: "pointer"
                  },
                  children: "Reset"
                })]
              }), [{
                key: "rotate",
                label: "Rotate",
                min: -180,
                max: 180
              }, {
                key: "skewX",
                label: "Skew X",
                min: -45,
                max: 45
              }, {
                key: "skewY",
                label: "Skew Y",
                min: -45,
                max: 45
              }].map(function (control) {
                var _active$style46;
                var values = getTransformValues((_active$style46 = active.style) === null || _active$style46 === void 0 ? void 0 : _active$style46.transform);
                return /*#__PURE__*/_jsxs("div", {
                  style: {
                    display: "flex",
                    flexDirection: "column",
                    gap: 4
                  },
                  children: [/*#__PURE__*/_jsxs("div", {
                    style: {
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: 12,
                      color: "#64748b"
                    },
                    children: [/*#__PURE__*/_jsx("span", {
                      children: control.label
                    }), /*#__PURE__*/_jsxs("span", {
                      children: [values[control.key], "\xB0"]
                    })]
                  }), /*#__PURE__*/_jsx("input", {
                    type: "range",
                    min: control.min,
                    max: control.max,
                    value: values[control.key],
                    onChange: function onChange(e) {
                      return css("transform", buildTransform(_objectSpread(_objectSpread({}, values), {}, _defineProperty({}, control.key, Number(e.target.value)))));
                    },
                    style: {
                      width: "100%",
                      cursor: "pointer",
                      accentColor: "#101828"
                    }
                  })]
                }, control.key);
              })]
            }), active.type !== "divider" && active.type !== "image" && active.type !== "html" && active.type !== "spacer" && active.type !== "social" && function () {
              var lh = parseLineHeight(styleTarget === null || styleTarget === void 0 ? void 0 : styleTarget.lineHeight, 1.5, "×");
              var isPx = lh.unit === "px";
              var sliderMin = isPx ? 10 : 0.8;
              var sliderMax = isPx ? 200 : 3;
              var sliderStep = isPx ? 1 : 0.05;
              return /*#__PURE__*/_jsxs("div", {
                style: {
                  display: "flex",
                  flexDirection: "column",
                  gap: 8
                },
                children: [/*#__PURE__*/_jsxs("div", {
                  style: {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 8
                  },
                  children: [/*#__PURE__*/_jsx("span", {
                    style: {
                      fontSize: 14,
                      fontWeight: 500,
                      color: "#4b5563"
                    },
                    children: "Line Height"
                  }), /*#__PURE__*/_jsxs("div", {
                    style: {
                      display: "flex",
                      alignItems: "center",
                      gap: 6
                    },
                    children: [/*#__PURE__*/_jsx("input", {
                      type: "number",
                      min: sliderMin,
                      max: isPx ? 500 : 5,
                      step: sliderStep,
                      value: lh.value,
                      onChange: function onChange(e) {
                        return css("lineHeight", formatLineHeight(e.target.value, lh.unit));
                      },
                      style: _objectSpread(_objectSpread({}, panelFieldStyle), {}, {
                        width: 64,
                        padding: "6px 8px",
                        fontSize: 12,
                        textAlign: "right"
                      })
                    }), /*#__PURE__*/_jsx("select", {
                      value: lh.unit,
                      onChange: function onChange(e) {
                        var nextUnit = e.target.value;
                        css("lineHeight", formatLineHeight(lh.value, nextUnit));
                      },
                      style: _objectSpread(_objectSpread({}, panelFieldStyle), {}, {
                        width: 56,
                        padding: "6px 4px",
                        fontSize: 11,
                        cursor: "pointer"
                      }),
                      "aria-label": "Line height unit",
                      children: LINE_HEIGHT_UNITS.map(function (unit) {
                        return /*#__PURE__*/_jsx("option", {
                          value: unit,
                          children: unit
                        }, unit);
                      })
                    })]
                  })]
                }), /*#__PURE__*/_jsx("input", {
                  type: "range",
                  min: sliderMin,
                  max: sliderMax,
                  step: sliderStep,
                  value: Math.min(sliderMax, Math.max(sliderMin, lh.value)),
                  onChange: function onChange(e) {
                    return css("lineHeight", formatLineHeight(e.target.value, lh.unit));
                  },
                  style: {
                    width: "100%",
                    cursor: "pointer",
                    accentColor: "#101828"
                  }
                })]
              });
            }(), active.type !== "divider" && active.type !== "image" && active.type !== "html" && active.type !== "spacer" && active.type !== "social" && function () {
              var lsRaw = styleTarget === null || styleTarget === void 0 ? void 0 : styleTarget.letterSpacing;
              var lsParsed = parseFloat(lsRaw);
              var letterSpacingPx = Number.isFinite(lsParsed) ? lsParsed : 0;
              var lsMin = -10;
              var lsMax = 20;
              return /*#__PURE__*/_jsxs("div", {
                style: {
                  display: "flex",
                  flexDirection: "column",
                  gap: 8
                },
                children: [/*#__PURE__*/_jsxs("div", {
                  style: {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 8
                  },
                  children: [/*#__PURE__*/_jsx("span", {
                    style: {
                      fontSize: 14,
                      fontWeight: 500,
                      color: "#4b5563"
                    },
                    children: "Letter Spacing"
                  }), /*#__PURE__*/_jsxs("div", {
                    style: {
                      display: "flex",
                      alignItems: "center",
                      gap: 6
                    },
                    children: [/*#__PURE__*/_jsx("input", {
                      type: "number",
                      min: lsMin,
                      max: lsMax,
                      step: 0.5,
                      value: letterSpacingPx,
                      onChange: function onChange(e) {
                        var next = Number(e.target.value);
                        var clamped = Number.isFinite(next) ? Math.min(lsMax, Math.max(lsMin, next)) : 0;
                        css("letterSpacing", "".concat(clamped, "px"));
                      },
                      style: _objectSpread(_objectSpread({}, panelFieldStyle), {}, {
                        width: 64,
                        padding: "6px 8px",
                        fontSize: 12,
                        textAlign: "right"
                      })
                    }), /*#__PURE__*/_jsx("span", {
                      style: {
                        fontSize: 11,
                        color: "#94a3b8",
                        width: 24
                      },
                      children: "px"
                    })]
                  })]
                }), /*#__PURE__*/_jsx("input", {
                  type: "range",
                  min: lsMin,
                  max: lsMax,
                  step: 0.5,
                  value: Math.min(lsMax, Math.max(lsMin, letterSpacingPx)),
                  onChange: function onChange(e) {
                    return css("letterSpacing", "".concat(e.target.value, "px"));
                  },
                  style: {
                    width: "100%",
                    cursor: "pointer",
                    accentColor: "#101828"
                  }
                })]
              });
            }(), active.type !== "divider" && active.type !== "spacer" && function () {
              var opacityRaw = styleTarget === null || styleTarget === void 0 ? void 0 : styleTarget.opacity;
              var opacityNum = opacityRaw === undefined || opacityRaw === null || opacityRaw === "" ? 1 : parseFloat(opacityRaw);
              var opacitySafe = Number.isFinite(opacityNum) ? Math.min(1, Math.max(0, opacityNum)) : 1;
              var opacityPct = Math.round(opacitySafe * 100);
              return /*#__PURE__*/_jsxs("div", {
                style: {
                  display: "flex",
                  flexDirection: "column",
                  gap: 8
                },
                children: [/*#__PURE__*/_jsxs("div", {
                  style: {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 8
                  },
                  children: [/*#__PURE__*/_jsx("span", {
                    style: {
                      fontSize: 14,
                      fontWeight: 500,
                      color: "#4b5563"
                    },
                    children: "Opacity"
                  }), /*#__PURE__*/_jsxs("div", {
                    style: {
                      display: "flex",
                      alignItems: "center",
                      gap: 6
                    },
                    children: [/*#__PURE__*/_jsx("input", {
                      type: "number",
                      min: 0,
                      max: 100,
                      step: 1,
                      value: opacityPct,
                      onChange: function onChange(e) {
                        var pct = Math.min(100, Math.max(0, parseInt(e.target.value, 10) || 0));
                        css("opacity", pct / 100);
                      },
                      style: _objectSpread(_objectSpread({}, panelFieldStyle), {}, {
                        width: 64,
                        padding: "6px 8px",
                        fontSize: 12,
                        textAlign: "right"
                      })
                    }), /*#__PURE__*/_jsx("span", {
                      style: {
                        fontSize: 11,
                        color: "#94a3b8",
                        width: 24
                      },
                      children: "%"
                    })]
                  })]
                }), /*#__PURE__*/_jsx("input", {
                  type: "range",
                  min: 0,
                  max: 100,
                  step: 1,
                  value: opacityPct,
                  onChange: function onChange(e) {
                    return css("opacity", Number(e.target.value) / 100);
                  },
                  style: {
                    width: "100%",
                    cursor: "pointer",
                    accentColor: "#101828"
                  }
                })]
              });
            }()]
          }), !isElementStyleMode && /*#__PURE__*/_jsxs("div", {
            style: {
              borderTop: "1px solid ".concat(UI.panelBorder),
              display: "flex",
              flexDirection: "column",
              gap: 20,
              padding: 20
            },
            children: [/*#__PURE__*/_jsx("span", {
              style: {
                fontSize: 16,
                fontWeight: 500,
                textTransform: "uppercase",
                color: "#101828"
              },
              children: "Borders & Effects"
            }), /*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 8
              },
              children: [/*#__PURE__*/_jsx("label", {
                style: {
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#4b5563"
                },
                children: "Border Style"
              }), /*#__PURE__*/_jsxs("select", {
                value: ((_active$style47 = active.style) === null || _active$style47 === void 0 ? void 0 : _active$style47.borderStyle) || "none",
                onChange: function onChange(e) {
                  return css("borderStyle", e.target.value);
                },
                style: _objectSpread(_objectSpread({}, panelFieldStyle), {}, {
                  padding: "6px 10px",
                  fontFamily: "DM Sans, sans-serif",
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#4b5563",
                  cursor: "pointer"
                }),
                children: [/*#__PURE__*/_jsx("option", {
                  value: "none",
                  children: "None"
                }), /*#__PURE__*/_jsx("option", {
                  value: "solid",
                  children: "Solid"
                }), /*#__PURE__*/_jsx("option", {
                  value: "dashed",
                  children: "Dashed"
                }), /*#__PURE__*/_jsx("option", {
                  value: "dotted",
                  children: "Dotted"
                })]
              })]
            }), ((_active$style48 = active.style) === null || _active$style48 === void 0 ? void 0 : _active$style48.borderStyle) && ((_active$style49 = active.style) === null || _active$style49 === void 0 ? void 0 : _active$style49.borderStyle) !== "none" && /*#__PURE__*/_jsxs(_Fragment, {
              children: [function (_active$style54, _active$style55, _active$style56) {
                var hasPerSide = ["Top", "Right", "Bottom", "Left"].some(function (side) {
                  var _active$style50;
                  return ((_active$style50 = active.style) === null || _active$style50 === void 0 ? void 0 : _active$style50["border".concat(side, "Width")]) !== undefined;
                });
                return /*#__PURE__*/_jsxs("div", {
                  style: {
                    display: "flex",
                    flexDirection: "column",
                    gap: 8
                  },
                  children: [/*#__PURE__*/_jsxs("div", {
                    style: {
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center"
                    },
                    children: [/*#__PURE__*/_jsx("span", {
                      style: {
                        fontSize: 14,
                        fontWeight: 500,
                        color: "#4b5563"
                      },
                      children: "Border Width"
                    }), /*#__PURE__*/_jsx("button", {
                      type: "button",
                      onClick: function onClick() {
                        if (hasPerSide) {
                          var _active$style51, _active$style52;
                          var w = ((_active$style51 = active.style) === null || _active$style51 === void 0 ? void 0 : _active$style51.borderTopWidth) || ((_active$style52 = active.style) === null || _active$style52 === void 0 ? void 0 : _active$style52.borderWidth) || "1px";
                          applyStylePatch(function (newStyle) {
                            newStyle.borderWidth = w;
                            ["Top", "Right", "Bottom", "Left"].forEach(function (side) {
                              delete newStyle["border".concat(side, "Width")];
                              delete newStyle["border".concat(side, "Style")];
                            });
                            delete newStyle.border;
                            return newStyle;
                          }, {
                            blockOnly: true
                          });
                        } else {
                          var _active$style53;
                          var _w = ((_active$style53 = active.style) === null || _active$style53 === void 0 ? void 0 : _active$style53.borderWidth) || "1px";
                          applyStylePatch(function (newStyle) {
                            ["Top", "Right", "Bottom", "Left"].forEach(function (side) {
                              newStyle["border".concat(side, "Width")] = _w;
                            });
                            delete newStyle.borderWidth;
                            delete newStyle.border;
                            return newStyle;
                          }, {
                            blockOnly: true
                          });
                        }
                      },
                      style: {
                        background: !hasPerSide ? "#F2F4F7" : "#101828",
                        border: "1px solid ".concat(!hasPerSide ? UI.inputBorder : "#101828"),
                        borderRadius: 6,
                        color: !hasPerSide ? "#4b5563" : "#ffffff",
                        padding: "4px 10px",
                        fontSize: 11,
                        cursor: "pointer",
                        fontWeight: 600,
                        fontFamily: "DM Sans, sans-serif"
                      },
                      children: !hasPerSide ? "All Sides" : "Per Side"
                    })]
                  }), !hasPerSide ? /*#__PURE__*/_jsxs("div", {
                    style: {
                      display: "flex",
                      flexDirection: "column",
                      gap: 6
                    },
                    children: [/*#__PURE__*/_jsxs("div", {
                      style: {
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: 13,
                        color: "#64748b"
                      },
                      children: [/*#__PURE__*/_jsx("span", {
                        children: "Uniform Width"
                      }), /*#__PURE__*/_jsx("span", {
                        children: ((_active$style54 = active.style) === null || _active$style54 === void 0 ? void 0 : _active$style54.borderWidth) !== undefined ? active.style.borderWidth : "1px"
                      })]
                    }), /*#__PURE__*/_jsx("input", {
                      type: "range",
                      min: "0",
                      max: "10",
                      value: Number.isFinite(parseInt((_active$style55 = active.style) === null || _active$style55 === void 0 ? void 0 : _active$style55.borderWidth, 10)) ? parseInt((_active$style56 = active.style) === null || _active$style56 === void 0 ? void 0 : _active$style56.borderWidth, 10) : 1,
                      onChange: function onChange(e) {
                        var val = e.target.value + "px";
                        applyStylePatch(function (newStyle) {
                          newStyle.borderWidth = val;
                          ["Top", "Right", "Bottom", "Left"].forEach(function (side) {
                            delete newStyle["border".concat(side, "Width")];
                          });
                          delete newStyle.border;
                          return newStyle;
                        }, {
                          blockOnly: true
                        });
                      },
                      style: {
                        width: "100%",
                        cursor: "pointer",
                        accentColor: "#101828"
                      }
                    })]
                  }) : /*#__PURE__*/_jsx("div", {
                    style: {
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gap: 8
                    },
                    children: ["Top", "Right", "Bottom", "Left"].map(function (side) {
                      var _active$style57, _active$style58, _active$style59, _active$style60, _active$style61;
                      return /*#__PURE__*/_jsxs("div", {
                        style: {
                          display: "flex",
                          flexDirection: "column",
                          gap: 4
                        },
                        children: [/*#__PURE__*/_jsx("span", {
                          style: {
                            fontSize: 10,
                            color: "#6b7280",
                            textTransform: "uppercase"
                          },
                          children: side
                        }), /*#__PURE__*/_jsxs("div", {
                          style: {
                            display: "flex",
                            gap: 4
                          },
                          children: [/*#__PURE__*/_jsx("input", {
                            type: "number",
                            min: "0",
                            max: "20",
                            value: parseInt((_active$style57 = (_active$style58 = active.style) === null || _active$style58 === void 0 ? void 0 : _active$style58["border".concat(side, "Width")]) !== null && _active$style57 !== void 0 ? _active$style57 : (_active$style59 = active.style) === null || _active$style59 === void 0 ? void 0 : _active$style59.borderWidth, 10) || 0,
                            onChange: function onChange(e) {
                              return css("border".concat(side, "Width"), "".concat(Math.max(0, Number(e.target.value)), "px"), {
                                blockOnly: true
                              });
                            },
                            style: _objectSpread(_objectSpread({}, panelFieldStyle), {}, {
                              minWidth: 0,
                              width: "50%",
                              padding: "6px"
                            })
                          }), /*#__PURE__*/_jsxs("select", {
                            value: ((_active$style60 = active.style) === null || _active$style60 === void 0 ? void 0 : _active$style60["border".concat(side, "Style")]) || ((_active$style61 = active.style) === null || _active$style61 === void 0 ? void 0 : _active$style61.borderStyle) || "solid",
                            onChange: function onChange(e) {
                              return css("border".concat(side, "Style"), e.target.value, {
                                blockOnly: true
                              });
                            },
                            style: _objectSpread(_objectSpread({}, panelFieldStyle), {}, {
                              minWidth: 0,
                              width: "50%",
                              padding: "6px 2px",
                              fontSize: 11
                            }),
                            children: [/*#__PURE__*/_jsx("option", {
                              value: "none",
                              children: "None"
                            }), /*#__PURE__*/_jsx("option", {
                              value: "solid",
                              children: "Solid"
                            }), /*#__PURE__*/_jsx("option", {
                              value: "dashed",
                              children: "Dash"
                            }), /*#__PURE__*/_jsx("option", {
                              value: "dotted",
                              children: "Dot"
                            })]
                          })]
                        })]
                      }, side);
                    })
                  })]
                });
              }(), /*#__PURE__*/_jsx(ColorPickerField, {
                label: "Border Color",
                value: ((_active$style62 = active.style) === null || _active$style62 === void 0 ? void 0 : _active$style62.borderColor) || (active.type === "divider" ? "#1C252E" : "#cbd5e1"),
                onChange: function onChange(val) {
                  return css("borderColor", val);
                }
              })]
            }), active.type !== "divider" && /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsxs("div", {
                style: {
                  display: "flex",
                  flexDirection: "column",
                  gap: 8
                },
                children: [/*#__PURE__*/_jsx("label", {
                  style: {
                    fontSize: 14,
                    fontWeight: 500,
                    color: "#4b5563"
                  },
                  children: "Inner Border (Frame)"
                }), /*#__PURE__*/_jsx("p", {
                  style: {
                    margin: 0,
                    fontSize: 12,
                    color: "#64748b"
                  },
                  children: "Draws a frame inside the block, inset from the edges."
                }), /*#__PURE__*/_jsxs("select", {
                  value: ((_active$style63 = active.style) === null || _active$style63 === void 0 ? void 0 : _active$style63.innerBorderStyle) || "none",
                  onChange: function onChange(e) {
                    return css("innerBorderStyle", e.target.value);
                  },
                  style: _objectSpread(_objectSpread({}, panelFieldStyle), {}, {
                    padding: "6px 10px",
                    fontFamily: "DM Sans, sans-serif",
                    fontSize: 14,
                    fontWeight: 500,
                    color: "#4b5563",
                    cursor: "pointer"
                  }),
                  children: [/*#__PURE__*/_jsx("option", {
                    value: "none",
                    children: "None"
                  }), /*#__PURE__*/_jsx("option", {
                    value: "solid",
                    children: "Solid"
                  }), /*#__PURE__*/_jsx("option", {
                    value: "dashed",
                    children: "Dashed"
                  }), /*#__PURE__*/_jsx("option", {
                    value: "dotted",
                    children: "Dotted"
                  })]
                })]
              }), ((_active$style64 = active.style) === null || _active$style64 === void 0 ? void 0 : _active$style64.innerBorderStyle) && ((_active$style65 = active.style) === null || _active$style65 === void 0 ? void 0 : _active$style65.innerBorderStyle) !== "none" && /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsxs("div", {
                  style: {
                    display: "flex",
                    flexDirection: "column",
                    gap: 8
                  },
                  children: [/*#__PURE__*/_jsxs("div", {
                    style: {
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: 14,
                      fontWeight: 500,
                      color: "#4b5563"
                    },
                    children: [/*#__PURE__*/_jsx("span", {
                      children: "Inner Border Width"
                    }), /*#__PURE__*/_jsx("span", {
                      style: {
                        color: "#64748b"
                      },
                      children: ((_active$style66 = active.style) === null || _active$style66 === void 0 ? void 0 : _active$style66.innerBorderWidth) !== undefined ? active.style.innerBorderWidth : "1px"
                    })]
                  }), /*#__PURE__*/_jsx("input", {
                    type: "range",
                    min: "0",
                    max: "8",
                    value: Number.isFinite(parseInt((_active$style67 = active.style) === null || _active$style67 === void 0 ? void 0 : _active$style67.innerBorderWidth, 10)) ? parseInt((_active$style68 = active.style) === null || _active$style68 === void 0 ? void 0 : _active$style68.innerBorderWidth, 10) : 1,
                    onChange: function onChange(e) {
                      return css("innerBorderWidth", "".concat(e.target.value, "px"));
                    },
                    style: {
                      width: "100%",
                      cursor: "pointer",
                      accentColor: "#101828"
                    }
                  })]
                }), /*#__PURE__*/_jsxs("div", {
                  style: {
                    display: "flex",
                    flexDirection: "column",
                    gap: 8
                  },
                  children: [/*#__PURE__*/_jsxs("div", {
                    style: {
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: 14,
                      fontWeight: 500,
                      color: "#4b5563"
                    },
                    children: [/*#__PURE__*/_jsx("span", {
                      children: "Inset from edge"
                    }), /*#__PURE__*/_jsx("span", {
                      style: {
                        color: "#64748b"
                      },
                      children: ((_active$style69 = active.style) === null || _active$style69 === void 0 ? void 0 : _active$style69.innerBorderInset) || "24px"
                    })]
                  }), /*#__PURE__*/_jsx("input", {
                    type: "range",
                    min: "4",
                    max: "80",
                    value: parseInt((_active$style70 = active.style) === null || _active$style70 === void 0 ? void 0 : _active$style70.innerBorderInset, 10) || 24,
                    onChange: function onChange(e) {
                      return css("innerBorderInset", "".concat(e.target.value, "px"));
                    },
                    style: {
                      width: "100%",
                      cursor: "pointer",
                      accentColor: "#101828"
                    }
                  })]
                }), /*#__PURE__*/_jsx(ColorPickerField, {
                  label: "Inner Border Color",
                  value: ((_active$style71 = active.style) === null || _active$style71 === void 0 ? void 0 : _active$style71.innerBorderColor) || "#d4af37",
                  onChange: function onChange(val) {
                    return css("innerBorderColor", val);
                  }
                })]
              })]
            }), active.type !== "divider" && /*#__PURE__*/_jsx(RadiusControls, {
              style: active.style,
              onUpdateCorner: updateRadiusCorner,
              onUpdateAll: updateRadiusAll,
              onUnlink: toggleRadiusMode
            }), active.type !== "divider" && /*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 8
              },
              children: [/*#__PURE__*/_jsx("label", {
                style: {
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#4b5563"
                },
                children: "Elevation & Shadow"
              }), /*#__PURE__*/_jsxs("select", {
                value: ((_active$style72 = active.style) === null || _active$style72 === void 0 ? void 0 : _active$style72.boxShadow) || "none",
                onChange: function onChange(e) {
                  return css("boxShadow", e.target.value);
                },
                style: _objectSpread(_objectSpread({}, panelFieldStyle), {}, {
                  fontFamily: "DM Sans, sans-serif",
                  fontSize: 14,
                  fontWeight: 500,
                  color: "#4b5563",
                  padding: "6px 10px",
                  cursor: "pointer"
                }),
                children: [/*#__PURE__*/_jsx("option", {
                  value: "none",
                  children: "None"
                }), /*#__PURE__*/_jsx("option", {
                  value: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
                  children: "Soft Drop"
                }), /*#__PURE__*/_jsx("option", {
                  value: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
                  children: "Medium Lift"
                }), /*#__PURE__*/_jsx("option", {
                  value: "0 10px 20px -3px rgba(99, 102, 241, 0.15), 0 4px 6px -2px rgba(99, 102, 241, 0.1)",
                  children: "Accent Shadow (Indigo)"
                }), /*#__PURE__*/_jsx("option", {
                  value: "0 20px 25px -5px rgba(0, 0, 0, 0.25), 0 10px 10px -5px rgba(0, 0, 0, 0.15)",
                  children: "Intense Glow"
                })]
              })]
            })]
          })]
        }), activeRightTab === "global" && /*#__PURE__*/_jsx(GlobalSettingsFields, {
          getActiveFontFamily: getActiveFontFamily,
          handleFontChange: handleFontChange,
          getActiveTextColor: getActiveTextColor,
          applyGlobalTextColor: applyGlobalTextColor,
          getActiveButtonBackgroundColor: getActiveButtonBackgroundColor,
          applyGlobalButtonBackgroundColor: applyGlobalButtonBackgroundColor,
          getActiveButtonTextColor: getActiveButtonTextColor,
          applyGlobalButtonTextColor: applyGlobalButtonTextColor,
          getActiveBackgroundColor: getActiveBackgroundColor,
          applyGlobalBackgroundColor: applyGlobalBackgroundColor,
          getActiveBackgroundImage: getActiveBackgroundImage,
          setGlobalBackgroundImageUrl: setGlobalBackgroundImageUrl,
          handleGlobalBackgroundImageUpload: handleGlobalBackgroundImageUpload,
          imageUploading: imageUploading,
          imageUploadError: imageUploadError,
          documentPadding: documentPadding,
          setDocumentPadding: setDocumentPadding,
          documentPageSize: documentPageSize,
          setDocumentPageSize: setDocumentPageSize,
          showSafeArea: showSafeArea,
          setShowSafeArea: setShowSafeArea,
          showGrid: showGrid,
          setShowGrid: setShowGrid
        }), activeRightTab === "saved-templates" && showSavedTemplates && /*#__PURE__*/_jsx(SavedTemplatePicker, {
          savedTemplates: savedTemplates,
          savedTemplatesLoading: savedTemplatesLoading,
          onSelectSavedTemplate: onSelectSavedTemplate
        })]
      }), activeRightTab !== "global" && activeRightTab !== "saved-templates" && /*#__PURE__*/_jsx("div", {
        style: {
          padding: 20,
          borderTop: "1px solid ".concat(UI.panelBorder)
        },
        children: /*#__PURE__*/_jsx("button", {
          onClick: remove,
          style: {
            width: "100%",
            background: "#ef4444",
            color: "#ffffff",
            border: "none",
            borderRadius: 8,
            padding: "12px 0",
            fontFamily: "DM Sans, sans-serif",
            fontSize: 14,
            fontWeight: 600,
            cursor: "pointer",
            transition: "all 0.2s"
          },
          onMouseEnter: function onMouseEnter(e) {
            e.currentTarget.style.background = "#dc2626";
          },
          onMouseLeave: function onMouseLeave(e) {
            e.currentTarget.style.background = "#ef4444";
          },
          children: "Delete Block"
        })
      })]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [showSavedTemplates && /*#__PURE__*/_jsxs("div", {
        style: {
          display: "flex",
          alignItems: "stretch",
          marginTop: 16,
          padding: "0 16px",
          borderBottom: "1px solid ".concat(UI.panelBorder)
        },
        children: [/*#__PURE__*/_jsx("button", {
          type: "button",
          onClick: function onClick() {
            return setActiveRightTab("global");
          },
          style: rightPanelTabStyle(activeRightTab !== "saved-templates"),
          children: "Design"
        }), /*#__PURE__*/_jsx("button", {
          type: "button",
          onClick: function onClick() {
            return setActiveRightTab("saved-templates");
          },
          style: rightPanelTabStyle(activeRightTab === "saved-templates"),
          title: "Templates",
          children: "Templates"
        })]
      }), showSavedTemplates && activeRightTab === "saved-templates" ? /*#__PURE__*/_jsx(SavedTemplatePicker, {
        savedTemplates: savedTemplates,
        savedTemplatesLoading: savedTemplatesLoading,
        onSelectSavedTemplate: onSelectSavedTemplate
      }) : /*#__PURE__*/_jsx(GlobalSettingsFields, {
        getActiveFontFamily: getActiveFontFamily,
        handleFontChange: handleFontChange,
        getActiveTextColor: getActiveTextColor,
        applyGlobalTextColor: applyGlobalTextColor,
        getActiveButtonBackgroundColor: getActiveButtonBackgroundColor,
        applyGlobalButtonBackgroundColor: applyGlobalButtonBackgroundColor,
        getActiveButtonTextColor: getActiveButtonTextColor,
        applyGlobalButtonTextColor: applyGlobalButtonTextColor,
        getActiveBackgroundColor: getActiveBackgroundColor,
        applyGlobalBackgroundColor: applyGlobalBackgroundColor,
        getActiveBackgroundImage: getActiveBackgroundImage,
        setGlobalBackgroundImageUrl: setGlobalBackgroundImageUrl,
        handleGlobalBackgroundImageUpload: handleGlobalBackgroundImageUpload,
        imageUploading: imageUploading,
        imageUploadError: imageUploadError,
        documentPadding: documentPadding,
        setDocumentPadding: setDocumentPadding,
        documentPageSize: documentPageSize,
        setDocumentPageSize: setDocumentPageSize,
        showSafeArea: showSafeArea,
        setShowSafeArea: setShowSafeArea,
        showGrid: showGrid,
        setShowGrid: setShowGrid
      })]
    })]
  });
  if (isCompact && isExpanded) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [rail, /*#__PURE__*/_jsx("div", {
        onClick: function onClick() {
          return onCollapse && onCollapse();
        },
        style: {
          position: "absolute",
          inset: 0,
          background: "rgba(15, 23, 42, 0.35)",
          zIndex: 40
        }
      }), /*#__PURE__*/_jsx("div", {
        style: {
          position: "absolute",
          top: 0,
          right: 56,
          bottom: 0,
          zIndex: 45,
          display: "flex"
        },
        children: panelBody
      })]
    });
  }
  return panelBody;
}